<template>
  <div class="container">
    <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>
    <div class="content c-top">
      <div class="bread-small">
        <span style="font-size: 18px; font-weight: bold; margin-right: 7px">商城管理</span>
        <span>/</span>
        <span style="
            margin-left: 6px;
            margin-right: 20px;
            cursor: pointer;
            color: #909099;
          " @click="toPage">首页弹窗</span>
        <span class="bread-active" style="cursor: pointer">首页装修</span>
      </div>
      <div class="page-content">
        <div class="modul">
          <div style="margin-bottom: 18px; margin-top: 3px">功能模块</div>
          <div
            :style="{ background: index == 0 || index == 7 || index == 8 || index == 9 ? '#8e95bf' : '#e9ecfe', cursor: index == 0 || index == 7 || index == 8 || index == 9 ? 'default' : 'pointer' }"
            class="modul-item" v-for="(item, index) in modulList" :key="index" @click="addModul(index)">
            <img src="../../../assets/icon_add_blue@2x.png" alt="" class="addicon" />
            <span>{{ item }}</span>
          </div>
        </div>
        <div class="phone-view">
          <div class="phone-scroll">
            <template v-for="(item, index) in viewData">
              <!-- 搜索模块 -->
              <!-- <div class="pr mg-bttom" :style="{ 'margin-bottom': item.margin ? item.margin + 'px' : '20px' }"
                @mouseleave="handleCloseBar($event, index)" @mouseenter="handleShowBar($event, index)"
                @click="handleView(index)" v-if="item.modelType == 1">
                <div class="phone-search">
                  <div class="search-left">
                    <img src="../../../assets/icon_search_36red@2x.png" class="search-icon" alt="" />
                    <p>请输入搜索内容</p>
                  </div>
                  <div class="search-btn">{{ item.modelDetail.navName || '搜索' }}</div>
                </div>
                <tool-bar v-show="item.showBar1 || item.showBar2" :viewIndex="index" @toDown="toDown" @toUp="toUp"
                  @toEdit="toEdit" @toDel="toDel" :viewlist="viewData"></tool-bar>
              </div> -->
              <!-- 轮播图模块 -->
              <div class="pr mg-bttom" :style="{ 'margin-bottom': item.margin ? item.margin + 'px' : '20px' }"
                @mouseleave="handleCloseBar($event, index)" @mouseenter="handleShowBar($event, index)"
                @click="handleView(index)" v-if="item.modelType == 2">
                <div class="swiper-box"
                  :style="{ height: item.radioHeight == '2' && item.height ? (item.height / 2 - 32) + 'px' : '124px' }">
                  <el-carousel indicator-position="none" arrow="never"
                    :height="item.radioHeight == '2' && item.height ? (item.height / 2 - 32) + 'px' : '124px'">
                    <el-carousel-item v-for="(sItem, sIndex) in item.modelDetail
                      .swiperImageList" :key="sIndex">
                      <img v-if="sItem.imgUrl" :src="sItem.imgUrl" class="swiper-img" alt="" />
                    </el-carousel-item>
                  </el-carousel>
                </div>
                <tool-bar v-show="item.showBar1 || item.showBar2" :viewIndex="index" @toDown="toDown" @toUp="toUp"
                  @toEdit="toEdit" @toDel="toDel" :viewlist="viewData"></tool-bar>
              </div>
              <!-- 分类导航模块 -->
              <div class="pr" :style="{ 'margin-bottom': item.margin ? item.margin + 'px' : '' }"
                @mouseleave="handleCloseBar($event, index)" @mouseenter="handleShowBar($event, index)"
                @click="handleView(index)" v-if="item.modelType == 3">
                <div class="two-num" :style="{
                  'justify-content':
                    item.modelDetail.categoryNavList.length == 2
                      ? 'space-around'
                      : '',
                }">
                  <div class="two-num-item" :style="{
                    flex:
                      item.modelDetail.categoryNavList.length == 2
                        ? 'flex'
                        : '',
                    width:
                      item.modelDetail.categoryNavList.length >= 5
                        ? '20%'
                        : '',
                  }" v-for="(itemx, indexx) in item.modelDetail.categoryNavList" :key="indexx">
                    <img :src="itemx.imgUrl ||
                      require('../../../assets/img_pic3@2x.png')
                      " alt="" class="nav-img" />
                    <p>
                      {{
                        itemx.categoryNavName
                        ? itemx.categoryNavName
                        : "分类导航" + (indexx + 1)
                      }}
                    </p>
                  </div>
                </div>
                <tool-bar v-show="item.showBar1 || item.showBar2" :viewIndex="index" @toDown="toDown" @toUp="toUp"
                  @toEdit="toEdit" @toDel="toDel" :viewlist="viewData"></tool-bar>
              </div>
              <!-- 图片导航模块 -->
              <div class="pr mg-bttom" :style="{ 'margin-bottom': item.margin ? item.margin + 'px' : '20px' }"
                @mouseleave="handleCloseBar($event, index)" @mouseenter="handleShowBar($event, index)"
                @click="handleView(index)" v-if="item.modelType == 4">
                <div class="active-box">
                  <div class="one-img">
                    <img :src="itemx.imgUrl ||
                      require('../../../assets/img_pic2@2x.png')
                      " alt="" class="active-img" v-for="(itemx, indexx) in item.modelDetail.imgList" :key="indexx" />
                  </div>
                </div>
                <tool-bar v-show="item.showBar1 || item.showBar2" :viewIndex="index" @toDown="toDown" @toUp="toUp"
                  @toEdit="toEdit" @toDel="toDel" :viewlist="viewData"></tool-bar>
              </div>
              <!-- 标题模块 -->
              <div class="pr mg-bttom" :style="{ 'margin-bottom': item.margin ? item.margin + 'px' : '20px' }"
                @mouseleave="handleCloseBar($event, index)" @mouseenter="handleShowBar($event, index)"
                @click="handleView(index)" v-if="item.modelType == 5">
                <div class="title-box" :style="{
                  'justify-content':
                    item.modelDetail.showType == 2 ? 'center' : '',
                }">
                  <div class="main-title">
                    {{ item.modelDetail.mainTitle || "主标题" }}
                  </div>
                  <div class="secondary-title">
                    {{ item.modelDetail.subTitle || "" }}
                  </div>
                </div>
                <tool-bar v-show="item.showBar1 || item.showBar2" :viewIndex="index" @toDown="toDown" @toUp="toUp"
                  @toEdit="toEdit" @toDel="toDel" :viewlist="viewData"></tool-bar>
              </div>
              <!-- 秒杀导航模块 -->
              <div class="pr mg-bttom" :style="{ 'margin-bottom': item.margin ? item.margin + 'px' : '20px' }"
                @mouseleave="handleCloseBar($event, index)" @mouseenter="handleShowBar($event, index)"
                @click="handleView(index)" v-if="item.modelType == 6">
                <div class="active-box">
                  <template v-for="itemx in item.modelDetail.activityNavList">
                    <!-- 一栏 -->
                    <div class="one-img" style="margin-bottom: 10px" v-if="itemx.showType == 5">
                      <img :src="require('../../../assets/act_box_bg.png')" alt="" class="active-img"
                        style="height: auto" />
                      <div class="act-info">
                        <div class="act-name">{{ itemx.navModel.activeName }}</div>
                        <div class="act-intro">{{ itemx.navModel.activeSubName }}</div>
                      </div>
                    </div>
                    <!-- 两栏 -->
                    <div class="two-img" style="margin-bottom: 10px" v-if="itemx.showType == 2">
                      <div class="two-img-box" style="margin-right: 5px;height: auto;">
                        <img :src="itemx.imgUrl ||
                          require('../../../assets/img_pic2@2x.png')
                          " alt="" class="active-img" style="height: 84px;" />
                        <p style="text-align: center;font-size: 12px;">{{ itemx.navModel.activeName }}</p>
                      </div>
                      <div class="two-img-box" style="height: auto;">
                        <img :src="itemx.children[0].imgUrl ||
                          require('../../../assets/img_pic2@2x.png')
                          " alt="" class="active-img" style="height: 84px;" />
                        <p style="text-align: center;font-size: 12px;">{{ itemx.children[0].navModel.activeName }}</p>
                      </div>
                    </div>
                    <!-- 三栏 -->
                    <div style="margin-bottom: 10px;display: flex;justify-content: space-between;"
                      v-if="itemx.showType == 3">
                      <img :src="itemx.imgUrl || require('../../../assets/img_pic2@2x.png')"
                        style="width: 203px;height: 275px;" alt="">
                      <div style="height: 275px;display: flex;flex-direction: column;justify-content: space-between;">
                        <img :src="itemx.children[0].imgUrl || require('../../../assets/img_pic2@2x.png')"
                          style="width: 137px;height: 141px;" alt="">
                        <img :src="itemx.children[1].imgUrl || require('../../../assets/img_pic2@2x.png')"
                          style="width: 137px;height: 126px;" alt="">
                      </div>
                    </div>
                  </template>
                </div>
                <tool-bar v-show="item.showBar1 || item.showBar2" :viewIndex="index" @toDown="toDown" @toUp="toUp"
                  @toEdit="toEdit" @toDel="toDel" :viewlist="viewData"></tool-bar>
              </div>
              <!-- 商品模块 -->
              <div class="pr mg-bttom" :style="{ 'margin-bottom': item.margin ? item.margin + 'px' : '20px' }"
                @mouseleave="handleCloseBar($event, index)" @mouseenter="handleShowBar($event, index)"
                @click="handleView(index)" v-if="item.modelType == 7">
                <div
                  style="width: 100%;display: flex;align-items: center;justify-content: space-between;padding: 12px 18px;box-sizing: border-box;">
                  <div style="display: flex;align-items: center;font-size: 12px;color: #F63C56;">
                    综合
                    <img style="width: 12px;height: 12px;" src="../../../assets/indexIcon/icon_next_24_2pxred.png" alt="">
                  </div>
                  <div style="display: flex;align-items: center;font-size: 12px;color: #333333;">
                    销量
                    <img style="width: 12px;height: 12px;margin-left: 4px;"
                      src="../../../assets/indexIcon/icon_next_24black.png" alt="">
                  </div>
                  <div style="display: flex;align-items: center;font-size: 12px;color: #333333;">
                    价格
                    <img style="width: 12px;height: 12px;margin-left: 4px;"
                      src="../../../assets/indexIcon/icon_next_24black.png" alt="">
                  </div>
                </div>
                <div style="width: 100%;overflow-y:auto;white-space:nowrap;margin-bottom:10px;"
                  v-if="item.modelDetail.goodsType == 2">
                  <div
                    style="padding:4px 15px;border-radius:14px;background-color:#FEF4F5;border:1px solid #F63C56;color:#F63C56;font-size:12px;margin-right:16px;display:inline-block;"
                    v-if="item.modelDetail.tagList.length > 0">{{ item.modelDetail.tagList[0].name }}</div>
                  <div
                    style="padding:4px 15px;border-radius:14px;background-color:#F5F5F5;font-size:12px;margin-right:16px;display:inline-block;"
                    v-for="(itemx, indexx) in item.modelDetail.tagList" :key="indexx" v-if="indexx > 0">{{ itemx.name }}
                  </div>
                </div>
                <div class="phone-goods" v-if="item.modelDetail.goodsType == 1">
                  <div class="phone-goods-item" v-for="itemx in item.modelDetail.viewGoodsList">
                    <img :src="itemx.imgUrl || itemx.mainImage" alt="" class="phone-goods-img" />
                    <div class="phone-goods-title">
                      <div v-if="itemx.resultType == 2" class="gift-tips">礼包</div>
                      {{ itemx.name }}
                    </div>
                    <div class="phone-goods-price">
                      <p class="retail-price">
                        <span style="font-size: 10px">￥</span>{{ itemx.price }}
                      </p>
                      <p class="market-price">已售{{ itemx.saleNum }}</p>
                    </div>
                  </div>
                </div>
                <div class="phone-goods" v-else>
                  <div class="phone-goods-item" v-for="itemx in item.modelDetail.tagGoodsList">
                    <img :src="itemx.imgUrl || itemx.headImg" alt="" class="phone-goods-img" />
                    <div class="phone-goods-title">
                      <div v-if="itemx.resultType == 2" class="gift-tips">礼包</div>{{ itemx.name }}
                    </div>
                    <div class="phone-goods-price">
                      <p class="retail-price">
                        <span style="font-size: 10px">￥</span>{{ itemx.price }}
                      </p>
                      <p class="market-price">已售{{ itemx.saleNum }}</p>
                    </div>
                  </div>
                </div>
                <tool-bar v-show="item.showBar1 || item.showBar2" :viewIndex="index" @toDown="toDown" @toUp="toUp"
                  @toEdit="toEdit" @toDel="toDel" :viewlist="viewData"></tool-bar>
              </div>
              <!-- 节日送礼 -->
              <div class="pr mg-bttom"
                :style="{ 'margin-bottom': item.margin ? item.margin + 'px' : '20px', 'padding': '0' }"
                @mouseleave="handleCloseBar($event, index)" @mouseenter="handleShowBar($event, index)"
                @click="handleView(index)" v-if="item.modelType == 8">
                <div class="festival-heng" :style="{ 'height': item.layoutType == '1' ? '169px' : '275px' }">
                  <div class="festival-top">
                    <p class="festival-title">{{ item.title }}</p>
                    <p class="festival-small-title">{{ item.subTitle }}</p>
                  </div>
                  <div class="festival-two" v-if="item.layoutType == '1'">
                    <div class="festival-two-item" v-for="(itemx, indexx) in item.modelDetail.imgList" :key="indexx">
                      <img :src="itemx.imgUrl || require('../../../assets/img_pic2@2x.png')" alt=""
                        class="festival-two-img" />
                      <div class="festival-date" v-if="itemx.festivalName && itemx.festivalDate">
                        距离{{ itemx.festivalName }}还有{{ itemx.days }}天</div>
                    </div>
                  </div>
                  <div class="festival-two" style="height: 224px;flex-direction: column;" v-if="item.layoutType == '2'">
                    <div class="festival-two-item" style="width: 100%;"
                      v-for="(itemx, indexx) in item.modelDetail.imgList" :key="indexx">
                      <img :src="itemx.imgUrl || require('../../../assets/img_pic2@2x.png')" alt=""
                        class="festival-two-img" />
                      <div class="festival-date" v-if="itemx.festivalName && itemx.festivalDate">
                        距离{{ itemx.festivalName }}还有{{ itemx.days }}天</div>
                    </div>
                  </div>
                </div>
                <tool-bar v-show="item.showBar1 || item.showBar2" :viewIndex="index" @toDown="toDown" @toUp="toUp"
                  @toEdit="toEdit" @toDel="toDel" :viewlist="viewData"></tool-bar>
              </div>
              <!-- 名义送礼 -->
              <div class="pr mg-bttom"
                :style="{ 'margin-bottom': item.margin ? item.margin + 'px' : '20px', 'padding': '0' }"
                @mouseleave="handleCloseBar($event, index)" @mouseenter="handleShowBar($event, index)"
                @click="handleView(index)" v-if="item.modelType == 9">
                <div class="festival-heng name-heng">
                  <div class="festival-top" style="align-items: center;justify-content: space-between;">
                    <div style="display: flex;align-items: center;">
                      <p class="festival-title">{{ item.title }}</p>
                      <p class="festival-small-title">{{ item.subTitle }}</p>
                    </div>
                    <div class="festival-btn" v-if="item.btnTitle">{{ item.btnTitle }}</div>
                  </div>
                  <div class="festival-two" style="display:block;height: 170px;margin-top: 14px;padding: 0;">
                    <div class="name-scrollbox">
                      <div class="name-item" v-for="(itemx, indexx) in item.modelDetail.labelList" :key="indexx">{{
                        itemx.labelName }}</div>
                      <div class="name-item-active">{{ item.modelDetail.labelList[0].labelName }}</div>
                    </div>
                    <div class="name-goods-box" style="">
                      <div class="name-goods-item" style="margin-right: 6px;"
                        v-for="(itemx, indexx) in item.modelDetail.labelList[0].goodsList" v-if="indexx < 4">
                        <img :src="itemx.image || itemx.headImg" class="name-goods-img" alt="">
                        <p class="name-goods-price"><span style="font-size:12px;">￥</span>{{ itemx.minPrice ||
                          itemx.price }}</p>
                      </div>
                    </div>
                  </div>

                </div>
                <tool-bar v-show="item.showBar1 || item.showBar2" :viewIndex="index" @toDown="toDown" @toUp="toUp"
                  @toEdit="toEdit" @toDel="toDel" :viewlist="viewData"></tool-bar>
              </div>
              <!-- 人群送礼 -->
              <div class="pr mg-bttom"
                :style="{ 'margin-bottom': item.margin ? item.margin + 'px' : '20px', 'padding': '0' }"
                @mouseleave="handleCloseBar($event, index)" @mouseenter="handleShowBar($event, index)"
                @click="handleView(index)" v-if="item.modelType == 10">
                <div class="festival-heng people-heng">
                  <div class="festival-top" style="align-items: center;justify-content: space-between;">
                    <div style="display: flex;align-items: center;">
                      <p class="festival-title">{{ item.title }}</p>
                      <p class="festival-small-title">{{ item.subTitle }}</p>
                    </div>
                    <div class="festival-btn" v-if="item.btnTitle">{{ item.btnTitle }}</div>
                  </div>
                  <div class="people-box">
                    <div class="people-left">
                      <div class="people-left-item" v-for="(itemx, indexx) in item.modelDetail.labelList" :key="indexx"
                        v-if="indexx < 7">
                        <span>{{ itemx.labelName }}</span>
                        <div class="people-left-item-active" v-if="indexx == 0">{{ itemx.labelName }}</div>
                      </div>
                    </div>
                    <div class="people-right">
                      <div class="people-right-item" v-for="(itemx, indexx) in item.modelDetail.labelList[0].goodsList"
                        :key="indexx">
                        <img :src="itemx.image || itemx.headImg" class="people-right-img" alt="">
                        <p><span style="font-size: 12px;">￥</span>{{ itemx.minPrice || itemx.price }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <tool-bar v-show="item.showBar1 || item.showBar2" :viewIndex="index" @toDown="toDown" @toUp="toUp"
                  @toEdit="toEdit" @toDel="toDel" :viewlist="viewData"></tool-bar>
              </div>
              <!-- 活动导航模块 -->
              <div class="pr mg-bttom" :style="{ 'margin-bottom': item.margin ? item.margin + 'px' : '20px' }"
                @mouseleave="handleCloseBar($event, index)" @mouseenter="handleShowBar($event, index)"
                @click="handleView(index)" v-if="item.modelType == 11">
                <div class="active-box">
                  <template v-for="itemx in item.modelDetail.activityNavList">
                    <!-- 一栏 -->
                    <div class="one-img" style="margin-bottom: 10px" v-if="itemx.showType == 5">
                      <img :src="itemx.imgUrl ||
                        require('../../../assets/img_pic2@2x.png')
                        " alt="" class="active-img" style="height: auto" />
                      <p style="text-align: center;font-size: 12px;">{{ itemx.navModel.activeName }}</p>
                    </div>
                    <!-- 两栏 -->
                    <div class="two-img" style="margin-bottom: 10px" v-if="itemx.showType == 2">
                      <div class="two-img-box" style="margin-right: 5px;height: auto;">
                        <img :src="itemx.imgUrl ||
                          require('../../../assets/img_pic2@2x.png')
                          " alt="" class="active-img" style="height: 84px;" />
                        <p style="text-align: center;font-size: 12px;">{{ itemx.navModel.activeName }}</p>
                      </div>
                      <div class="two-img-box" style="height: auto;">
                        <img :src="itemx.children[0].imgUrl ||
                          require('../../../assets/img_pic2@2x.png')
                          " alt="" class="active-img" style="height: 84px;" />
                        <p style="text-align: center;font-size: 12px;">{{ itemx.children[0].navModel.activeName }}</p>
                      </div>
                    </div>
                    <!-- 三栏 -->
                    <div style="margin-bottom: 10px;display: flex;justify-content: space-between;"
                      v-if="itemx.showType == 3">
                      <img :src="itemx.imgUrl || require('../../../assets/img_pic2@2x.png')"
                        style="width: 203px;height: 275px;" alt="">
                      <div style="height: 275px;display: flex;flex-direction: column;justify-content: space-between;">
                        <img :src="itemx.children[0].imgUrl || require('../../../assets/img_pic2@2x.png')"
                          style="width: 137px;height: 141px;" alt="">
                        <img :src="itemx.children[1].imgUrl || require('../../../assets/img_pic2@2x.png')"
                          style="width: 137px;height: 126px;" alt="">
                      </div>
                    </div>
                  </template>
                </div>
                <tool-bar v-show="item.showBar1 || item.showBar2" :viewIndex="index" @toDown="toDown" @toUp="toUp"
                  @toEdit="toEdit" @toDel="toDel" :viewlist="viewData"></tool-bar>
              </div>
              <!-- 图片导航模块 -->
              <div class="pr1 mg-bttom" :style="{ 'margin-bottom': item.margin ? item.margin + 'px' : '20px' }"
                @mouseleave="handleCloseBar($event, index)" @mouseenter="handleShowBar($event, index)"
                @click="handleView(index)" v-if="item.modelType == 12">
                <img v-if="item.modelDetail.imgList.length == 1" :src="itemx.imgUrl ||
                  require('@/assets/img_pic2@2x.png')
                  " alt="" class="active-img1" v-for="(itemx, indexx) in item.modelDetail.imgList" :key="indexx" />
                <div v-if="item.modelDetail.imgList.length != 1">
                  <el-carousel indicator-position="none" arrow="never" height="124px">
                    <el-carousel-item v-for="(sItem, sIndex) in item.modelDetail.imgList" :key="sIndex">
                      <img :src="sItem.imgUrl" style="width: 100%;height: 100%;" alt="" />
                    </el-carousel-item>
                  </el-carousel>
                </div>

                <tool-bar v-show="item.showBar1 || item.showBar2" :viewIndex="index" @toDown="toDown" @toUp="toUp"
                  @toEdit="toEdit" @toDel="toDel" :viewlist="viewData"></tool-bar>
              </div>
              <!-- 商品排行榜模块 -->
              <div class="pr mg-bttom" :style="{ 'margin-bottom': item.margin ? item.margin + 'px' : '20px' }"
                @mouseleave="handleCloseBar($event, index)" @mouseenter="handleShowBar($event, index)"
                @click="handleView(index)" v-if="item.modelType == 13">
                <div class="goodFirst">
                  <div style="display:flex;">
                    <div v-for="(it, inx) in item.modelDetail.goodsList" :key="inx" class="goods-Item">
                      <img style="width:143px;height: 143px;z-index:9;position:absolute;left:0px;top:0px"
                        v-if="it.mainImage != ''"
                        src="https://fenxiao.muruji.com/internalSystem/0a35b9c5-8a21-4816-a3cc-8bc9d0dd4f54" />
                      <img v-if="it.mainImage != ''"
                        style="width:143px;height: 143px;z-index:8;position:absolute;left:0px;top:0px;border-radius: 6px;"
                        :src="it.mainImage" />
                      <img v-if="it.mainImage == ''" style="width:143px;height: 143px;z-index:9"
                        src="https://fenxiao.muruji.com/internalSystem/d6aa7641-aa6d-44e7-a598-ea6656814b36" />
                      <div style="height: 151px;" v-if="it.mainImage != ''"></div>
                      <div class="goods-Item-num">
                        NO.{{ inx + 1 }}
                      </div>
                      <!-- <div class="goods-Item-status">已售罄</div> -->
                      <div style="position: relative;height: 20px;overflow-y: hidden;">
                        <img src="https://fenxiao.muruji.com/internalSystem/5751ffec-2668-4e16-becf-65409ef27cc7"
                          style="width: 36px;height: 16px;margin-right: 14px;float: left;position:absolute;top:4px" />
                        <span style="font-weight: bold;font-size: 12px;color: #333333;margin-left: 42px;">{{
                          it.name }}</span>
                      </div>
                      <div
                        style="display: flex;justify-content: space-between;align-items: center;width: 100%;height: 16px;margin-top: 4px;">
                        <div class="g-discount" v-if="it.discount">{{ it.discount }}折</div>
                        <div class="g-sale">已售{{ it.saleNum }}件</div>
                      </div>
                      <div
                        style=" margin-left: 6px;width: 131px;height: 44px;background: #FFF0F6;border-radius: 6px 6px 6px 6px;margin-top:8px; box-sizing: border-box;display: flex;justify-content: space-between;align-items: center;">
                        <div style="margin-left: 5px;">
                          <div style="color: #F63C56;font-weight: bold;">
                            <span style="font-size: 10px;">￥</span>
                            <span style="font-size: 15px;">{{
                              String(it.price).split('.')[0] || '0'
                            }}</span>
                            <span style="font-size: 10px;">.{{
                              String(it.price).split('.')[1] || '00' }}</span>
                          </div>
                          <div style="font-size: 10px;color: #999999;text-decoration:line-through">
                            ￥{{ it.originalPrice }}
                          </div>
                        </div>
                        <div style="margin-top: 6px;"><img style="width: 44rpx;height: 44px;"
                            src="https://fenxiao.muruji.com/internalSystem/45c622ff-37e6-4b08-8721-e82c707da6ab" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <tool-bar v-show="item.showBar1 || item.showBar2" :viewIndex="index" @toDown="toDown" @toUp="toUp"
                  @toEdit="toEdit" @toDel="toDel" :viewlist="viewData"></tool-bar>
              </div>
            </template>
          </div>
        </div>
        <div class="page-right" v-if="viewData.length > 0 && viewIndex > -1">
          <span class="edit-title">内容编辑</span>
          <div class="line"></div>
          <div class="edit-top">
            <div class="edit-name" v-if="viewData[viewIndex].modelType == 1">
              搜索框设置
            </div>
            <div class="edit-name" v-if="viewData[viewIndex].modelType == 2">
              轮播图设置
              <span style="color: #909099; font-weight: 500">（最多可上传10张轮播图）</span>
            </div>

            <div class="edit-name" v-if="viewData[viewIndex].modelType == 3">
              分类导航设置
              <span style="color: #909099; font-weight: 500">（图标建议JPG、JPEG、PNG格式，大小94*94px，5M以内）</span>
            </div>
            <div class="edit-name" v-if="viewData[viewIndex].modelType == 5">
              标题导航设置
            </div>
            <div class="edit-name" v-if="viewData[viewIndex].modelType == 4">
              图片导航设置
              <span style="color: #909099; font-weight: 500">（图标建议JPG、JPEG、PNG格式，宽度尺寸建议684px，5M以内）</span>
            </div>
            <div class="edit-name" v-if="viewData[viewIndex].modelType == 6">
              秒杀专区导航设置
              <span style="color: #909099; font-weight: 500">（图标建议JPG、JPEG、PNG格式，5M以内）</span>
            </div>
            <div class="edit-name" v-if="viewData[viewIndex].modelType == 7">
              商品导航设置
            </div>
            <div class="edit-name" v-if="viewData[viewIndex].modelType == 8">
              <span style="margin-right: 22px;">节日送礼设置</span>
              <el-radio v-model="viewData[viewIndex].layoutType" label="1">横版</el-radio>
              <el-radio v-model="viewData[viewIndex].layoutType" label="2">竖版</el-radio>
              <span style="color: #909099; font-weight: 500"
                v-if="viewData[viewIndex].layoutType == '2'">（图片建议JPG、JPEG、PNG格式，尺寸建议698px*196px，5M以内）</span>
              <span style="color: #909099; font-weight: 500"
                v-if="viewData[viewIndex].layoutType == '1'">（图片建议JPG、JPEG、PNG格式，尺寸建议328px*196px，5M以内）</span>
            </div>
            <div class="edit-name" v-if="viewData[viewIndex].modelType == 9">
              名义送礼设置
            </div>
            <div class="edit-name" v-if="viewData[viewIndex].modelType == 10">
              人群送礼设置
            </div>
            <div class="edit-name" v-if="viewData[viewIndex].modelType == 11">
              活动专区导航设置
              <span style="color: #909099; font-weight: 500">（图标建议JPG、JPEG、PNG格式，5M以内）</span>
            </div>
            <div class="edit-name" v-if="viewData[viewIndex].modelType == 12">
              100%屏幕宽图设置
              <span style="color: #909099; font-weight: 500">（图标建议JPG、JPEG、PNG格式，宽度尺寸建议684px，5M以内）</span>
            </div>
            <div class="edit-name" v-if="viewData[viewIndex].modelType == 13">
              排行榜设置
            </div>
            <el-button v-if="viewData[viewIndex].modelType == 2 ||
              viewData[viewIndex].modelType == 3 ||
              viewData[viewIndex].modelType == 4 ||
              viewData[viewIndex].modelType == 11
              " type="primary" @click="addNav(viewIndex, viewData[viewIndex].modelType)">添加导航</el-button>
            <el-button v-if="viewData[viewIndex].modelType == 8" type="primary"
              @click="showModulSetting(viewIndex, viewData[viewIndex].modelType)">模块设置</el-button>
            <el-button v-if="viewData[viewIndex].modelType == 13" type="primary"
              @click="addNav(viewIndex, viewData[viewIndex].modelType)">新增排行榜设置</el-button>
            <el-button v-if="viewData[viewIndex].modelType == 12" type="primary"
              @click="addNav(viewIndex, viewData[viewIndex].modelType)">新增图片</el-button>
            <div style="display: flex;" v-if="viewData[viewIndex].modelType == 9 || viewData[viewIndex].modelType == 10">
              <el-button type="primary"
                @click="showModulSetting(viewIndex, viewData[viewIndex].modelType)">模块设置</el-button>
              <el-button type="primary" @click="addNav(viewIndex, viewData[viewIndex].modelType)">添加导航</el-button>
            </div>

          </div>
          <div style="margin-bottom: 18px;color: #606266;">
            <span style="font-size: 14px;">模块间距：</span>
            <el-input style="width:300px;" size="mini" v-model="viewData[viewIndex].margin"
              placeholder="请输入间距大小（不输入选择默认高度）单位px"></el-input>
          </div>
          <div class="edit-name" style="margin-bottom:20px;" v-if="viewData[viewIndex].modelType == 2">
            <el-radio v-model="viewData[viewIndex].radioHeight" label="1">标准高度<span
                style="color:#909099">(标准尺寸698*260px)</span></el-radio>
            <el-radio v-model="viewData[viewIndex].radioHeight" label="2">自定义高度</el-radio>
            <el-input v-if="viewData[viewIndex].radioHeight == '2'" v-model="viewData[viewIndex].height" size="mini"
              style="width:120px;" placeholder="请输入高度 px"></el-input>
          </div>
          <!-- 搜索框模块 -->
          <div v-if="viewData[viewIndex].modelType == 1">
            <el-form>
              <el-form-item label="导航名称：" label-width="100px">
                <el-input placeholder="请输入导航名称" maxlength="6" v-model="viewData[viewIndex].modelDetail.navName"
                  style="width:200px;" show-word-limit></el-input>
              </el-form-item>
              <el-form-item label="关联页面：" label-width="100px">
                <div style="
                    width: 442px;
                    height: 36px;
                    background: #e9ecfe;
                    color: #2d46ee;
                    line-height: 36px;
                    padding-left: 10px;
                  " @click="
                    showDialog(
                      viewIndex,
                      0,
                      viewData[viewIndex].modelDetail.navModel.navType,
                      viewData[viewIndex].modelDetail.navModel.goodsSelectedId
                    )
                    ">
                  {{ viewData[viewIndex].modelDetail.navModel.funcName }}
                </div>
              </el-form-item>
            </el-form>
          </div>
          <!-- 轮播图模块 -->
          <div v-if="viewData[viewIndex].modelType == 2">
            <el-table :data="viewData[viewIndex].modelDetail.swiperImageList" :header-cell-style="{
              background: '#F5F6FA',
              color: '#303033',
              'font-weight': 'bold',
              'text-align': 'left',
            }">
              <el-table-column label="排序" width="70">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="名称">
                <template slot-scope="scope">
                  <el-input placeholder="请输入内容" v-model="scope.row.imgName"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="图片" prop="imgUrl" width="150px">
                <template slot-scope="scope">
                  <upload-picture :imageUrl="scope.row.imgUrl"
                    @getUrl="getImage($event, viewIndex, scope.$index)"></upload-picture>
                </template>
              </el-table-column>
              <el-table-column label="关联类型" width="150px">
                <template slot-scope="scope">
                  <p v-if="scope.row.navModel.navType == 0">-</p>
                  <p v-if="scope.row.navModel.navType == 1">功能跳转</p>
                  <p v-if="scope.row.navModel.navType == 2">商品</p>
                  <p v-if="scope.row.navModel.navType == 3">页面/活动</p>
                </template>
              </el-table-column>
              <el-table-column label="关联页面">
                <template slot-scope="scope">
                  <div class="toselect" @click="
                    showDialog(
                      viewIndex,
                      scope.$index,
                      scope.row.navModel.navType,
                      scope.row.navModel.goodsSelectedId
                    )
                    ">
                    {{ scope.row.navModel.funcName }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <span style="margin-right: 12px; color: #2d46ee; cursor: pointer" v-if="scope.$index <
                    viewData[viewIndex].modelDetail.swiperImageList.length - 1
                    " @click="toTableDown(viewIndex, scope.$index)">下移</span>
                  <span style="margin-right: 12px; color: #2d46ee; cursor: pointer" v-if="scope.$index > 0"
                    @click="toTabelUp(viewIndex, scope.$index)">上移</span>
                  <span style="color: red; cursor: pointer" @click="tableDel(viewIndex, scope.$index)">删除</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 分类导航模块 -->
          <div v-if="viewData[viewIndex].modelType == 3">
            <el-table :data="viewData[viewIndex].modelDetail.categoryNavList" :header-cell-style="{
              background: '#F5F6FA',
              color: '#303033',
              'font-weight': 'bold',
              'text-align': 'left',
            }">
              <el-table-column label="排序" width="70">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="图标" prop="imgUrl" width="150px">
                <template slot-scope="scope">
                  <upload-picture :imageUrl="scope.row.imgUrl"
                    @getUrl="getImage($event, viewIndex, scope.$index)"></upload-picture>
                </template>
              </el-table-column>
              <el-table-column label="名称">
                <template slot-scope="scope">
                  <el-input placeholder="请输入内容" v-model="scope.row.categoryNavName"></el-input>
                </template>
              </el-table-column>

              <el-table-column label="关联类型" width="150px">
                <template slot-scope="scope">
                  <p v-if="scope.row.navModel.navType == 0">-</p>
                  <p v-if="scope.row.navModel.navType == 1">功能跳转</p>
                  <p v-if="scope.row.navModel.navType == 2">商品</p>
                  <p v-if="scope.row.navModel.navType == 3">页面/活动</p>
                </template>
              </el-table-column>
              <el-table-column label="关联页面">
                <template slot-scope="scope">
                  <div class="toselect" @click="
                    showDialog(
                      viewIndex,
                      scope.$index,
                      scope.row.navModel.navType,
                      scope.row.navModel.goodsSelectedId
                    )
                    ">
                    {{ scope.row.navModel.funcName }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <span style="margin-right: 12px; color: #2d46ee; cursor: pointer" v-if="scope.$index <
                    viewData[viewIndex].modelDetail.categoryNavList.length - 1
                    " @click="toTableDown(viewIndex, scope.$index)">下移</span>
                  <span style="margin-right: 12px; color: #2d46ee; cursor: pointer" v-if="scope.$index > 0"
                    @click="toTabelUp(viewIndex, scope.$index)">上移</span>
                  <span style="color: red; cursor: pointer" @click="tableDel(viewIndex, scope.$index)">删除</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 图片导航模块 -->
          <div v-if="viewData[viewIndex].modelType == 4">
            <el-table :data="viewData[viewIndex].modelDetail.imgList" :header-cell-style="{
              background: '#F5F6FA',
              color: '#303033',
              'font-weight': 'bold',
              'text-align': 'left',
            }">
              <el-table-column label="排序" width="70">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="图片" prop="imgUrl" width="150px">
                <template slot-scope="scope">
                  <upload-picture :imageUrl="scope.row.imgUrl"
                    @getUrl="getImage($event, viewIndex, scope.$index)"></upload-picture>
                </template>
              </el-table-column>
              <el-table-column label="关联类型" width="150px">
                <template slot-scope="scope">
                  <p v-if="scope.row.navModel.navType == 0">-</p>
                  <p v-if="scope.row.navModel.navType == 1">功能跳转</p>
                  <p v-if="scope.row.navModel.navType == 2">商品</p>
                  <p v-if="scope.row.navModel.navType == 3">页面/活动</p>
                </template>
              </el-table-column>
              <el-table-column label="关联页面">
                <template slot-scope="scope">
                  <div class="toselect" @click="
                    showDialog(
                      viewIndex,
                      scope.$index,
                      scope.row.navModel.navType,
                      scope.row.navModel.goodsSelectedId
                    )
                    ">
                    {{ scope.row.navModel.funcName }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <span style="margin-right: 12px; color: #2d46ee; cursor: pointer" v-if="scope.$index <
                    viewData[viewIndex].modelDetail.imgList.length - 1
                    " @click="toTableDown(viewIndex, scope.$index)">下移</span>
                  <span style="margin-right: 12px; color: #2d46ee; cursor: pointer" v-if="scope.$index > 0"
                    @click="toTabelUp(viewIndex, scope.$index)">上移</span>
                  <span style="color: red; cursor: pointer" @click="tableDel(viewIndex, scope.$index)">删除</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 标题导航模块 -->
          <div v-if="viewData[viewIndex].modelType == 5">
            <el-form>
              <el-form-item label="主标题名称" label-width="100px" size="small">
                <el-input placeholder="请输入主标题名称" v-model="viewData[viewIndex].modelDetail.mainTitle" style="width: 300px"
                  show-word-limit maxlength="6"></el-input>
              </el-form-item>
              <el-form-item label="显示方式" label-width="100px" size="small">
                <el-radio v-model="viewData[viewIndex].modelDetail.showType" :label="1">居左</el-radio>
                <el-radio v-model="viewData[viewIndex].modelDetail.showType" :label="2">居中</el-radio>
              </el-form-item>
              <el-form-item label="副标题名称" label-width="100px" size="small">
                <el-input placeholder="请输入副标题名称" v-model="viewData[viewIndex].modelDetail.subTitle" style="width: 300px"
                  show-word-limit maxlength="6"></el-input>
              </el-form-item>
              <el-form-item label="关联页面" label-width="100px" size="small" style="margin-top: 20px">
                <div style="
                    width: 442px;
                    height: 36px;
                    background: #e9ecfe;
                    color: #2d46ee;
                    line-height: 36px;
                    padding-left: 10px;
                  " @click="
                    showDialog(
                      viewIndex,
                      0,
                      viewData[viewIndex].modelDetail.navModel.navType,
                      viewData[viewIndex].modelDetail.navModel.goodsSelectedId
                    )
                    ">
                  {{ viewData[viewIndex].modelDetail.navModel.funcName }}
                </div>
              </el-form-item>
            </el-form>
          </div>
          <!-- 秒杀导航模块 -->
          <div v-if="viewData[viewIndex].modelType == 6 && expendAll">
            <el-table :data="viewData[viewIndex].modelDetail.activityNavList" row-key="id" default-expand-all
              :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" :header-cell-style="{
                background: '#F5F6FA',
                color: '#303033',
                'font-weight': 'bold',
                'text-align': 'left',
              }">
              <!-- <el-table-column label="排序" width="80px">
                <template slot-scope="scope" v-if="scope.row.showType == 5">
                  <p>{{ scope.row.id }}</p>
                </template>
              </el-table-column> -->
              <!-- <el-table-column label="排版类型" width="150px">
                <template slot-scope="scope">
                  <div v-if="scope.row.oneLan == 1">
                    <el-select v-model="scope.row.showType" placeholder="请选择"
                      @change="getShowType($event, viewIndex, scope.row.id)">
                      <el-option label="一栏" :value="5"></el-option>
                      <el-option label="两栏" :value="2"></el-option>
                      <el-option label="三栏" :value="3"></el-option>
                    </el-select>
                  </div>
                  <p v-if="scope.row.showType == 3 && scope.row.oneLan != 1">子类</p>
                </template>
              </el-table-column> -->
              <!-- <el-table-column label="图片" prop="imgUrl" width="150px">
                <template slot="header">
                  <el-popover placement="bottom-end" width="250" trigger="hover" style="overflow: hidden; padding: 0"
                    visible-arrow="false">
                    <div class="active-pic-tips">
                      <p class="active-pic-title">一栏（高度不限制）</p>
                      <div class="onegag">
                        <p>建议尺寸</p>
                        <p>686*168px</p>
                      </div> -->
              <!-- <img src="../../../assets/img_pic3@2x (1).png" style="width:230px;height:54px;" alt=""> -->
              <!-- <p class="active-pic-title">两栏</p>
                      <div style="display: flex; justify-content: space-between">
                        <div class="onegag twogag">
                          <p>建议尺寸</p>
                          <p>338*168px</p>
                        </div>
                        <div class="onegag twogag">
                          <p>建议尺寸</p>
                          <p>338*168px</p>
                        </div>
                      </div>
                      <p class="active-pic-title">三栏</p>
                      <div style="display: flex;justify-content: space-between;">
                        <div class="onegag twogag"
                          style="width: 120px;height: 140px;background-size: 100% 100%;justify-content: center;">
                          <p>建议尺寸</p>
                          <p>406*550px</p>
                        </div>
                        <div class=""
                          style="width: 104px;height: 140px;display: flex;flex-direction: column;justify-content: space-between;">
                          <div class="onegag"
                            style="width: 100%;height: 67px;background-size: 100% 100%;padding: 0;margin: 0;justify-content: center;">
                            <p>建议尺寸</p>
                            <p>406*550px</p>
                          </div>
                          <div class="onegag"
                            style="width: 100%;height: 67px;background-size: 100% 100%;padding: 0;margin: 0;justify-content: center;">
                            <p>建议尺寸</p>
                            <p>406*550px</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="display: flex; align-items: center;justify-content: center;" slot="reference">
                      <p>图片</p>
                      <img style="width: 18px; height: 18px" src="../../../assets/icon/icon_qipao.png" />
                    </div>
                  </el-popover>
                </template>
                <template slot-scope="scope">
                  <upload-picture :imageUrl="scope.row.imgUrl"
                    @getUrl="getImage($event, viewIndex, scope.row)"></upload-picture>
                </template>
              </el-table-column> -->
              <!-- <el-table-column label="关联类型" width="100px">
                <template slot-scope="scope">
                  <p v-if="scope.row.navModel.navType == 0">-</p>
                  <p v-if="scope.row.navModel.navType == 1">功能跳转</p>
                  <p v-if="scope.row.navModel.navType == 2">商品</p>
                  <p v-if="scope.row.navModel.navType == 3">页面/活动</p>
                </template>
              </el-table-column> -->
              <!-- <el-table-column label="关联页面">
                <template slot-scope="scope">
                  <div class="toselect" @click="
                    showDialog(
                      viewIndex,
                      scope.row,
                      scope.row.navModel.navType,
                      scope.row.navModel.goodsSelectedId
                    )
                    ">
                    {{ scope.row.navModel.funcName }}
                  </div>
                </template>
              </el-table-column> -->
              <el-table-column label="活动名称" width="190px">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.navModel.activeName" placeholder="请输入名称" maxlength="8"
                    show-word-limit></el-input>
                </template>
              </el-table-column>
              <el-table-column label="活动副标题">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.navModel.activeSubName" placeholder="请输入副标题" maxlength="20"
                    show-word-limit></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="100px">
                <template slot-scope="scope">
                  <span style="margin-right: 12px; color: #2d46ee; cursor: pointer"
                    v-if="scope.$index < viewData[viewIndex].modelDetail.activityNavList.length - 1 && scope.row.oneLan == 1"
                    @click="toTableDown(viewIndex, scope.row.id)">下移</span>
                  <span style="margin-right: 12px; color: #2d46ee; cursor: pointer"
                    v-if="scope.$index > 0 && scope.row.oneLan == 1" @click="toTabelUp(viewIndex, scope.row.id)">上移</span>
                  <span style="color: red; cursor: pointer"
                    @click="tableDel(viewIndex, scope.row.id, scope.row, scope.$index)">删除</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 商品导航模块 -->
          <div v-if="viewData[viewIndex].modelType == 7">
            <div style="display: flex; align-items: center">
              <p style="font-size: 14px; margin-right: 18px;">商品类型：</p>
              <!-- <el-radio v-model="viewData[viewIndex].modelDetail.goodsType" :label="1">商品选择</el-radio> -->
              <el-radio v-model="viewData[viewIndex].modelDetail.goodsType" :label="2">标签选择</el-radio>
            </div>
            <el-button style="margin-top: 10px;margin-left: 70px;" v-if="viewData[viewIndex].modelDetail.goodsType == 1"
              type="primary" @click="showGoodsDialog(viewIndex)">选择商品</el-button>
            <div style="display: flex;margin-top: 20px;" v-if="viewData[viewIndex].modelDetail.goodsType == 2">
              <p style="font-size: 14px; margin-right: 18px;">商品标签：</p>
              <div style="display: flex;flex-wrap: wrap;width:534px;">
                <div class="tag-item" style="margin-bottom:15px;"
                  :class="{ 'tag-item-active': item.selected, 'tag-disabled': !item.disabled }"
                  v-for="(item, index) in goodsTagList" :key="item.id" @click="selectGoodsTagFn(item.id, item.disabled)">
                  {{
                    item.name }}</div>
              </div>
            </div>
            <div
              v-if="viewData[viewIndex].modelDetail.goodsList.length > 0 && viewData[viewIndex].modelDetail.goodsType == 1">
              <el-table :data="viewData[viewIndex].modelDetail.goodsList">
                <el-table-column label="排序" width="80px">
                  <template slot-scope="scope">
                    <span>{{ scope.$index + 1 }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="商品图片" width="100px">
                  <template slot-scope="scope">
                    <img :src="scope.row.imgUrl || scope.row.mainImg" style="width: 64px; height: 64px" />
                  </template>
                </el-table-column>
                <el-table-column label="商品名称" prop="name"></el-table-column>
                <el-table-column label="操作" align="center" width="150px">
                  <template slot-scope="scope">
                    <span style="
                        margin-right: 12px;
                        color: #2d46ee;
                        cursor: pointer;
                      " v-if="scope.$index <
                        viewData[viewIndex].modelDetail.goodsList.length - 1
                        " @click="toTableDown(viewIndex, scope.$index)">下移</span>
                    <span style="
                        margin-right: 12px;
                        color: #2d46ee;
                        cursor: pointer;
                      " v-if="scope.$index > 0" @click="toTabelUp(viewIndex, scope.$index)">上移</span>
                    <span style="color: red; cursor: pointer" @click="tableDel(viewIndex, scope.$index)">删除</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <!-- 节日送礼导航模块 -->
          <div v-if="viewData[viewIndex].modelType == 8">
            <el-table :data="viewData[viewIndex].modelDetail.imgList" :header-cell-style="{
              background: '#F5F6FA',
              color: '#303033',
              'font-weight': 'bold',
              'text-align': 'left',
            }">
              <el-table-column label="排序" width="70">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="图片" prop="imgUrl" width="150px">
                <template slot-scope="scope">
                  <upload-picture :imageUrl="scope.row.imgUrl"
                    @getUrl="getImage($event, viewIndex, scope.$index)"></upload-picture>
                </template>
              </el-table-column>
              <el-table-column label="关联类型" width="150px">
                <template slot-scope="scope">
                  <p v-if="scope.row.navModel.navType == 0">-</p>
                  <p v-if="scope.row.navModel.navType == 1">功能跳转</p>
                  <p v-if="scope.row.navModel.navType == 2">商品</p>
                  <p v-if="scope.row.navModel.navType == 3">页面/活动</p>
                </template>
              </el-table-column>
              <el-table-column label="关联页面">
                <template slot-scope="scope">
                  <div class="toselect" @click="
                    showDialog(
                      viewIndex,
                      scope.$index,
                      scope.row.navModel.navType,
                      scope.row.navModel.goodsSelectedId
                    )
                    ">
                    {{ scope.row.navModel.funcName }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="节日名称">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.festivalName" :name="'xx' + scope.$index"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="节日时间">
                <template slot-scope="scope">
                  <el-date-picker v-model="scope.row.festivalDate"
                    @change="getDateChange($event, viewIndex, scope.$index)" value-format="yyyy-MM-dd"
                    style="width: 140px;" type="date" placeholder="选择日期"></el-date-picker>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <span style="margin-right: 12px; color: #2d46ee; cursor: pointer" v-if="scope.$index <
                    viewData[viewIndex].modelDetail.imgList.length - 1
                    " @click="toTableDown(viewIndex, scope.$index)">下移</span>
                  <span style="margin-right: 12px; color: #2d46ee; cursor: pointer" v-if="scope.$index > 0"
                    @click="toTabelUp(viewIndex, scope.$index)">上移</span>
                  <!-- <span style="color: red; cursor: pointer" @click="tableDel(viewIndex, scope.$index)">删除</span> -->
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 名义送礼导航模块 -->
          <div v-if="viewData[viewIndex].modelType == 9">
            <el-table :data="viewData[viewIndex].modelDetail.labelList" :header-cell-style="{
              background: '#F5F6FA',
              color: '#303033',
              'font-weight': 'bold',
              'text-align': 'center',
            }">
              <el-table-column label="排序" width="70">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="选择名义标签" align="center">
                <template slot-scope="scope">
                  <div style="display: flex;justify-content: center;">
                    <div class="toselect" style="width: 100px;" @click="
                      showTagDialog(
                        viewIndex,
                        scope.$index,
                        scope.row.labelId,
                        'name'
                      )
                      ">
                      {{ scope.row.labelName || '请选择名义标签' }}
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <span style="margin-right: 12px; color: #2d46ee; cursor: pointer" v-if="scope.$index <
                    viewData[viewIndex].modelDetail.labelList.length - 1
                    " @click="toTableDown(viewIndex, scope.$index)">下移</span>
                  <span style="margin-right: 12px; color: #2d46ee; cursor: pointer" v-if="scope.$index > 0"
                    @click="toTabelUp(viewIndex, scope.$index)">上移</span>
                  <span style="color: red; cursor: pointer" @click="tableDel(viewIndex, scope.$index)">删除</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 人群送礼导航模块 -->
          <div v-if="viewData[viewIndex].modelType == 10">
            <el-table :data="viewData[viewIndex].modelDetail.labelList" :header-cell-style="{
              background: '#F5F6FA',
              color: '#303033',
              'font-weight': 'bold',
              'text-align': 'center',
            }">
              <el-table-column label="排序" width="70">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="选择人群标签" align="center">
                <template slot-scope="scope">
                  <div style="display: flex;justify-content: center;">
                    <div class="toselect" style="width: 100px;" @click="
                      showTagDialog(
                        viewIndex,
                        scope.$index,
                        scope.row.labelId,
                        'people'
                      )
                      ">
                      {{ scope.row.labelName || '请选择人群标签' }}
                    </div>
                  </div>
                </template>
              </el-table-column>
              <!-- <el-table-column label="关联类型" width="150px">
                <template slot-scope="scope">
                  <p v-if="scope.row.navModel.navType == 0">-</p>
                  <p v-if="scope.row.navModel.navType == 1">功能跳转</p>
                  <p v-if="scope.row.navModel.navType == 2">商品</p>
                  <p v-if="scope.row.navModel.navType == 3">页面/活动</p>
                </template>
              </el-table-column>
              <el-table-column label="关联页面">
                <template slot-scope="scope">
                  <div class="toselect" @click="
                    showDialog(
                      viewIndex,
                      scope.$index,
                      scope.row.navModel.navType,
                      scope.row.navModel.goodsSelectedId
                    )
                    ">
                    {{ scope.row.navModel.funcName }}
                  </div>
                </template>
              </el-table-column> -->
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <span style="margin-right: 12px; color: #2d46ee; cursor: pointer" v-if="scope.$index <
                    viewData[viewIndex].modelDetail.labelList.length - 1
                    " @click="toTableDown(viewIndex, scope.$index)">下移</span>
                  <span style="margin-right: 12px; color: #2d46ee; cursor: pointer" v-if="scope.$index > 0"
                    @click="toTabelUp(viewIndex, scope.$index)">上移</span>
                  <span style="color: red; cursor: pointer" @click="tableDel(viewIndex, scope.$index)">删除</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 活动导航模块 -->
          <div v-if="viewData[viewIndex].modelType == 11 && expendAll">
            <el-table :data="viewData[viewIndex].modelDetail.activityNavList" row-key="id" default-expand-all
              :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" :header-cell-style="{
                background: '#F5F6FA',
                color: '#303033',
                'font-weight': 'bold',
                'text-align': 'left',
              }">
              <el-table-column label="排序" width="80px">
                <template slot-scope="scope" v-if="scope.row.showType == 5">
                  <p>{{ scope.row.id }}</p>
                </template>
              </el-table-column>
              <el-table-column label="排版类型" width="150px">
                <template slot-scope="scope">
                  <div v-if="scope.row.oneLan == 1">
                    <el-select v-model="scope.row.showType" placeholder="请选择"
                      @change="getShowType($event, viewIndex, scope.row.id)">
                      <el-option label="一栏" :value="5"></el-option>
                      <el-option label="两栏" :value="2"></el-option>
                      <el-option label="三栏" :value="3"></el-option>
                    </el-select>
                  </div>
                  <p v-if="scope.row.showType == 3 && scope.row.oneLan != 1">子类</p>
                </template>
              </el-table-column>
              <el-table-column label="图片" prop="imgUrl" width="150px">
                <template slot="header">
                  <el-popover placement="bottom-end" width="250" trigger="hover" style="overflow: hidden; padding: 0"
                    visible-arrow="false">
                    <div class="active-pic-tips">
                      <p class="active-pic-title">一栏（高度不限制）</p>
                      <div class="onegag">
                        <p>建议尺寸</p>
                        <p>686*168px</p>
                      </div>
                      <!-- <img src="../../../assets/img_pic3@2x (1).png" style="width:230px;height:54px;" alt=""> -->
                      <p class="active-pic-title">两栏</p>
                      <div style="display: flex; justify-content: space-between">
                        <div class="onegag twogag">
                          <p>建议尺寸</p>
                          <p>338*168px</p>
                        </div>
                        <div class="onegag twogag">
                          <p>建议尺寸</p>
                          <p>338*168px</p>
                        </div>
                      </div>
                      <p class="active-pic-title">三栏</p>
                      <div style="display: flex;justify-content: space-between;">
                        <div class="onegag twogag"
                          style="width: 120px;height: 140px;background-size: 100% 100%;justify-content: center;">
                          <p>建议尺寸</p>
                          <p>406*550px</p>
                        </div>
                        <div class=""
                          style="width: 104px;height: 140px;display: flex;flex-direction: column;justify-content: space-between;">
                          <div class="onegag"
                            style="width: 100%;height: 67px;background-size: 100% 100%;padding: 0;margin: 0;justify-content: center;">
                            <p>建议尺寸</p>
                            <p>406*550px</p>
                          </div>
                          <div class="onegag"
                            style="width: 100%;height: 67px;background-size: 100% 100%;padding: 0;margin: 0;justify-content: center;">
                            <p>建议尺寸</p>
                            <p>406*550px</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="display: flex; align-items: center;justify-content: center;" slot="reference">
                      <p>图片</p>
                      <img style="width: 18px; height: 18px" src="../../../assets/icon/icon_qipao.png" />
                    </div>
                  </el-popover>
                </template>
                <template slot-scope="scope">
                  <upload-picture :imageUrl="scope.row.imgUrl"
                    @getUrl="getImage($event, viewIndex, scope.row)"></upload-picture>
                </template>
              </el-table-column>
              <el-table-column label="关联类型" width="100px">
                <template slot-scope="scope">
                  <p v-if="scope.row.navModel.navType == 0">-</p>
                  <p v-if="scope.row.navModel.navType == 1">功能跳转</p>
                  <p v-if="scope.row.navModel.navType == 2">商品</p>
                  <p v-if="scope.row.navModel.navType == 3">页面/活动</p>
                </template>
              </el-table-column>
              <el-table-column label="关联页面">
                <template slot-scope="scope">
                  <div class="toselect" @click="
                    showDialog(
                      viewIndex,
                      scope.row,
                      scope.row.navModel.navType,
                      scope.row.navModel.goodsSelectedId
                    )
                    ">
                    {{ scope.row.navModel.funcName }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="活动名称">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.navModel.activeName" placeholder="请输入名称" maxlength="8"
                    show-word-limit></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <span style="margin-right: 12px; color: #2d46ee; cursor: pointer"
                    v-if="scope.$index < viewData[viewIndex].modelDetail.activityNavList.length - 1 && scope.row.oneLan == 1"
                    @click="toTableDown(viewIndex, scope.row.id)">下移</span>
                  <span style="margin-right: 12px; color: #2d46ee; cursor: pointer"
                    v-if="scope.$index > 0 && scope.row.oneLan == 1" @click="toTabelUp(viewIndex, scope.row.id)">上移</span>
                  <span style="color: red; cursor: pointer"
                    @click="tableDel(viewIndex, scope.row.id, scope.row, scope.$index)">删除</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-if="viewData[viewIndex].modelType == 12">
            <el-table :data="viewData[viewIndex].modelDetail.imgList" :header-cell-style="{
              background: '#F5F6FA',
              color: '#303033',
              'font-weight': 'bold',
              'text-align': 'left',
            }
              ">
              <el-table-column label="排序" width="70">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="图片" prop="imgUrl" width="150px">
                <template slot-scope="scope">
                  <upload-picture :imageUrl="scope.row.imgUrl"
                    @getUrl="getImage($event, viewIndex, scope.$index)"></upload-picture>
                </template>
              </el-table-column>
              <el-table-column label="关联类型" width="150px">
                <template slot-scope="scope">
                  <p v-if="scope.row.navModel.navType == 0">-</p>
                  <p v-if="scope.row.navModel.navType == 1">功能跳转</p>
                  <p v-if="scope.row.navModel.navType == 2">商品</p>
                  <p v-if="scope.row.navModel.navType == 3">页面/活动</p>
                </template>
              </el-table-column>
              <el-table-column label="关联页面">
                <template slot-scope="scope">
                  <div class="toselect" @click="
                    showDialog(
                      viewIndex,
                      scope.$index,
                      scope.row.navModel.navType,
                      scope.row.navModel.goodsSelectedId
                    )
                    ">
                    {{ scope.row.navModel.funcName }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <span style="margin-right: 12px; color: #2d46ee; cursor: pointer" v-if="scope.$index <
                    viewData[viewIndex].modelDetail.imgList.length - 1
                    " @click="toTableDown(viewIndex, scope.$index)">下移</span>
                  <span style="margin-right: 12px; color: #2d46ee; cursor: pointer" v-if="scope.$index > 0"
                    @click="toTabelUp(viewIndex, scope.$index)">上移</span>
                  <span style="color: red; cursor: pointer" @click="tableDel(viewIndex, scope.$index)">删除</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 排行榜模块 -->
          <div v-if="viewData[viewIndex].modelType == 13">
            <el-table :data="viewData[viewIndex].modelDetail.viewGoodsList" :header-cell-style="{
              background: '#F5F6FA',
              color: '#303033',
              'font-weight': 'bold',
              'text-align': 'left',
            }
              ">
              <el-table-column label="排序" width="70">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="关联商品">
                <template slot-scope="scope">
                  <div class="toselect" @click="
                    showDialog(
                      viewIndex,
                      scope.$index,
                      '2',
                      scope.row.navModel.goodsSelectedId
                    )
                    ">
                    {{ scope.row.navModel.funcName }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <span style="margin-right: 12px; color: #2d46ee; cursor: pointer" v-if="scope.$index <
                    viewData[viewIndex].modelDetail.viewGoodsList.length - 1
                    " @click="toTableDown(viewIndex, scope.$index)">下移</span>
                  <span style="margin-right: 12px; color: #2d46ee; cursor: pointer" v-if="scope.$index > 0"
                    @click="toTabelUp(viewIndex, scope.$index)">上移</span>
                  <span style="color: red; cursor: pointer" @click="tableDel(viewIndex, scope.$index)">删除</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="bottom-box">
        <div class="bottom-btn" @click="saveIndexTemplate">保存</div>
      </div>
    </div>
    <el-dialog title="功能选择" :append-to-body="true" :visible.sync="dialogVisible" width="898px">
      <div class="function-box">
        <div class="function-left">
          <div class="function-item" :class="{ 'function-item-active': functionIndex == index,'hide-menu':!showGoodsLink&&item!='商品' }"
            v-for="(item, index) in functionLeft" :key="index" @click="selectFunction(index)">
            <span>{{ item }}</span>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
        <div class="function-right">
          <div class="nopage" v-if="functionIndex == 0">
            <div class="select-box select-box-active">
              <el-radio v-model="radio" label="1">不关联页面</el-radio>
            </div>
          </div>
          <div class="nopage" v-if="functionIndex == 1">
            <div class="select-box" :class="{ 'select-box-active': item.funcId == functionInletRadio }"
              v-for="item in functionInlet" @click="getFunctionName(item.funcName, item.funcUrl)">
              <el-radio v-model="functionInletRadio" :label="item.funcId">{{
                item.funcName
              }}</el-radio>
            </div>
          </div>
          <!-- 分类标签 -->
          <div class="nopage" v-show="false">
            <div style="display: flex; margin-bottom: 30px;">
              <input type="text" class="search-ipt" v-model="tagName" placeholder="请输入标签名称" />
              <el-button type="primary" size="mini" style="height: 36px; line-height: normal; margin-left: 18px"
                @click="getLabelList">查询</el-button>
            </div>
            <div class="select-box" :class="{ 'select-box-active': item.id == labelId }" v-for="item in labelList">
              <el-radio v-model="labelId" :label="item.id">{{
                item.tagName
              }}</el-radio>
            </div>
            <div class="pagibox" style="position: static;justify-content: center;margin-top: 20px;">
              <el-pagination @size-change="handleSizeChangeLabel" @current-change="handleCurrentChangeLabel"
                :current-page="labelPageNo" :page-sizes="[5, 10, 20, 30]" :page-size="labelPageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="labelTotalNum">
              </el-pagination>
            </div>
          </div>
          <!-- 分类类目 -->
          <div class="nopage" v-show="false">
            <div style="display: flex">
              <input type="text" class="search-ipt" v-model="categoryName" placeholder="请输入类目名称" />
              <el-button type="primary" size="mini" style="height: 36px; line-height: normal; margin-left: 18px"
                @click="searchCate">查询</el-button>
            </div>
            <div class="categary-box">
              <div class="categary-item" :class="{ 'categary-active': item.id == rootCategoryId }"
                v-for="(item, index) in rootCategory" :key="index" @click="swicthRootCate(item.id, item.name)">
                {{ item.name }}
              </div>
            </div>
            <div style="height: 72%; overflow-y: auto">
              <div class="select-box" :class="{ 'select-box-active': item.id == categoryId }"
                v-for="(item, index) in category" :key="item.id" @click="swicthCate(item.id, item.name)">
                <el-radio v-model="categoryId" :label="item.id">{{
                  item.name
                }}</el-radio>
              </div>
            </div>
            <div class="pagibox" style="position: static">
              <el-pagination @size-change="handleSizeChangecate" @current-change="handleCurrentChangecate"
                :current-page="catePageNo" :page-sizes="[5, 10, 20, 30]" :page-size="catePageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="cateTotalNum">
              </el-pagination>
            </div>
          </div>
          <!-- 商品 -->
          <div class="nopage" style="position: relative; width: 100%; height: 100%" v-if="functionIndex == 2">
            <div style="display: flex; margin-bottom: 18px">
              <div class="goods-type-button" :class="{ 'goods-type-active': goodsType == 1 }" @click="selectType(1)">普通商品
              </div>
              <div class="goods-type-button" :class="{ 'goods-type-active': goodsType == 2 }" @click="selectType(2)">礼包商品
              </div>
              <input type="text" class="search-ipt" v-model="goodsInfo" placeholder="请输入商品名称/商品编号" />
              <el-button type="primary" size="mini" style="height: 36px; line-height: normal; margin-left: 18px"
                @click="searchGoods">查询</el-button>
            </div>
            <div style="height: 83%; overflow-y: auto">
              <div class="select-box select-goods" :class="{
                'select-box-active': item.itemNo == goodsSelectedId,
              }" v-for="item in goodsList" @click="getGoodsName(item.name)">
                <el-radio v-model="goodsSelectedId" :label="item.itemNo">
                  <div class="goods-box">
                    <img :src="item.mainImg" alt="" class="goods-img" />
                    <div>
                      <p>{{ item.name }}</p>
                      <p class="goods-num">商品编号：{{ item.itemNo }}</p>
                    </div>
                  </div>
                </el-radio>
              </div>
            </div>
            <div class="pagibox" style="position: static">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="goodsPageNo" :page-sizes="[5, 10, 20, 30]" :page-size="goodsPageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="goodsTotalNum">
              </el-pagination>
            </div>
          </div>
          <!-- 页面设置 -->
          <div class="nopage" v-if="functionIndex == 3">
            <div style="display: flex; margin-bottom: 30px;">
              <div class="goods-type-button" :class="{ 'goods-type-active': pageType == 1 }" @click="selectPageType(1)">
                页面设置
              </div>
              <div class="goods-type-button" :class="{ 'goods-type-active': pageType == 2 }" @click="selectPageType(2)">
                营销活动
              </div>
              <input type="text" class="search-ipt" v-model="searchForm.title"
                :placeholder="pageType == 1 ? '请输入页面标题' : '请输入活动名称'" />
              <el-button type="primary" size="mini" style="height: 36px; line-height: normal; margin-left: 18px"
                @click="searchForm.pageNo = 1; getPageList()">查询</el-button>
            </div>
            <div class="select-box" :class="{ 'select-box-active': item.id == pageId }" v-for="item in pageList">
              <el-radio v-model="pageId" :label="item.id">{{
                item.title || item.name
              }}</el-radio>
            </div>
            <div class="pagibox" style="position: static;justify-content: center;margin-top: 20px;">
              <el-pagination @size-change="handleSizeChangePage" @current-change="handleCurrentChangePage"
                :current-page="searchForm.pageNo" :page-sizes="[5, 10, 20, 30]" :page-size="searchForm.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="pageTotalNum">
              </el-pagination>
            </div>
          </div>
          <!-- 小程序跳转 -->
          <div class="nopage" v-if="functionIndex == 4">
            <el-form label-width="120px" ref="form" :rules="rules" :model="form">
                <el-form-item label="小程序原始id" prop="gId">
                    <el-input v-model="form.gId" placeholder="请输入小程序原始id（gh开头）"></el-input>
                </el-form-item>
                <el-form-item label="小程序appid" prop="appId">
                    <el-input v-model="form.appId" placeholder="请输入小程序appid（wx开头）"></el-input>
                </el-form-item>
                <el-form-item label="跳转地址">
                    <el-input v-model="form.appUrl" placeholder="请输入跳转地址"></el-input>
                </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="checkConfirm">确 认</el-button>
      </span>
    </el-dialog>
    <el-dialog append-to-body :visible.sync="goodsDialogVisible" width="900px">
      <div slot="title">选择商品</div>
      <div>
        <div style="
            display: flex;
            margin-bottom: 18px;
            position: absolute;
            right: 24px;
            top: 70px;
            z-index: 99;
          ">
          <div style="display: flex;margin-right: 20px;">
            <div class="goods-type-button" :class="{ 'goods-type-active': goodsType == 1 }" @click="selectType(1)">普通商品
            </div>
            <div class="goods-type-button" :class="{ 'goods-type-active': goodsType == 2 }" @click="selectType(2)">礼包商品
            </div>
          </div>
          <input type="text" class="search-ipt" style="width: 300px" v-model="goodsInfo" placeholder="请输入商品名称/商品编号" />
          <el-button type="primary" size="mini" style="height: 36px; line-height: normal; margin-left: 18px"
            @click="searchGoods">查询</el-button>
        </div>
        <el-table :data="goodsList" style="width: 100%" ref="goodsTable" @selection-change="handleSelectionChange">
          <el-table-column type="selection" label="全选" width="55">
          </el-table-column>
          <el-table-column>
            <template slot-scope="scope">
              <div style="display: flex; align-items: center; height: 48px">
                <img :src="scope.row.imgUrl || scope.row.mainImg" alt=""
                  style="width: 48px; height: 48px; margin-right: 8px" />
                <div style="
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                  ">
                  <p>{{ scope.row.name }}</p>
                  <p class="goods-num">商品编号：{{ scope.row.itemNo }}</p>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagibox" style="position: static">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="goodsPageNo"
          :page-sizes="[5, 10, 20, 30]" :page-size="goodsPageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="goodsTotalNum">
        </el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="goodsDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="goodsConfirmFn">确 认</el-button>
      </span>
    </el-dialog>
    <el-dialog append-to-body :visible.sync="modulBox" width="600px">
      <div slot="title">
        模块设置
      </div>
      <div>
        <el-form :model="modulData" label-width="100px">
          <el-form-item label="模块标题" size="small">
            <el-input v-model="modulData.title" style="width: 300px;" maxlength="6" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="模块副标题" size="small">
            <el-input v-model="modulData.subTitle" style="width: 300px;" maxlength="15" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="按钮标题" size="small" v-if="viewData[viewIndex] && viewData[viewIndex].modelType != 8">
            <el-input v-model="modulData.btnTitle" style="width: 300px;" maxlength="4" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="按钮跳转" size="small" v-if="viewData[viewIndex] && viewData[viewIndex].modelType != 8">
            <template>
              <div class="toselect" style="width: 300px;" @click="showDialog(viewIndex, 'title', modulData.navType)">
                {{ modulData.funcName }}
              </div>
            </template>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="modulBox = false">取消</el-button>
        <el-button type="primary" @click="titleFn()">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog append-to-body :visible.sync="tagDialog" width="600px">
      <div slot="title" v-if="viewData[viewIndex]">
        {{ viewData[viewIndex].modelType == 10 ? '选择人群标签' : '选择名义标签' }}
      </div>
      <div style="display: flex;flex-wrap: wrap;">
        <div class="tag-item" style="margin-bottom:14px;" :class="{ 'tag-item-active': tagActiveId == item.id }"
          v-for="(item, index) in nameLabelList" :key="item.id" @click="selectTagFn(item.id)">{{ item.name }}</div>
      </div>
      <div slot="footer">
        <el-button @click="tagDialog = false">取消</el-button>
        <el-button type="primary" @click="confirmTag()">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog append-to-body :visible.sync="delDialogVisible" width="600px">
      <div slot="title">
        <i class="el-icon-warning" style="color: red"></i>
        提示信息
      </div>
      <div>删除后不可恢复数据，是否继续？</div>
      <div slot="footer">
        <el-button @click="delDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="deleteViewFn()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import toolBar from '../../../components/toolBar.vue'
import uploadPicture from '@/components/upload/mallPicture.vue'
export default {
  components: {
    breadcrumbTop,
    breadcrumbSearch,
    toolBar,
    uploadPicture
  },
  data() {
    return {
      tagActiveId: null,
      tagDialog: false,
      modulBox: false,
      goodsType: 1,
      pageType: 1,
      dataList: {
        list: [
          { title: 'APP设置', path: '', type: '0' },
          { title: '首页装修', path: '', type: '1' }
        ]
      },
      popData: [
        {
          imgUrl: '',
          navType: 0,
          funcName: '',
          navUrl: '',
          id: ''
        }
      ],
      dialogVisible: false,
      delDialogVisible: false,
      showGoodsLink:true,
      functionLeft: ['无', '功能入口', '商品', '页面/活动','小程序跳转'],
      form:{
          gId:'',
          appId:'',
          appUrl:'',
      },
      functionIndex: 0,
      radio: '1',
      functionInlet: [
        { label: '1', name: '消息中心' },
        { label: '2', name: '服务商管理' },
        { label: '3', name: '地址管理' },
        { label: '4', name: '银行卡' },
        { label: '5', name: '佣金管理' },
        { label: '6', name: '余额管理' },
        { label: '7', name: '积分商城' },
        { label: '8', name: '粉丝管理' },
        { label: '9', name: '订单中心' },
        { label: '10', name: '加入服务商' }
      ],
      functionInletRadio: '',
      modulList: ['搜索功能', '轮播图', '分类导航', '图片导航', '标题导航', '秒杀导航', '商品导航', '节日送礼', '名义送礼', '人群送礼', '活动导航', '100%屏幕宽图', '商品排行榜'],
      nav: [1, 2, 3, 4],
      viewData: [],
      delIndex: 0,
      viewIndex: 0,
      goodsPageNo: 1,
      goodsPageSize: 10,
      goodsSelectedId: null,
      goodsInfo: '',
      goodsTotalNum: 0,
      goodsList: [],
      catePageNo: 1,
      catePageSize: 10,
      categoryName: '',
      cateTotalNum: 0,
      rootCategoryId: '',
      categoryId: '',
      rootCategory: [],
      category: [],
      imageUrl: '',
      rowIndex: 0,
      pageName: '',
      goodsDialogVisible: false,
      selectedGoods: [],
      activeRow: {},
      pid: null,
      radioHeight: '1',
      classifyType: '1',
      labelPageNo: 1,
      labelPageSize: 10,
      tagName: '',
      labelTotalNum: 0,
      labelList: [],
      labelId: null,
      searchForm: {
        title: '', // 	否 	string 	账号名称名称
        status: true,
        createdTimeStart: '',
        createdTimeEnd: '',
        pageNo: 1,
        pageSize: 10
      },
      pageList: [],
      pageTotalNum: 0,
      pageId: null,
      modulData: {},
      nameLabelList: [],
      tagRowIndex: 0,
      tagType: '',
      goodsTagList: [],
      navUrl: '',
      expendAll: false,
      rules:{
          gId: [
              { required: true, message: '请输入小程序原始ID', trigger: 'blur' },
          ],
          appId: [
              { required: true, message: '请输入小程序原始ID', trigger: 'blur' },
          ],
      }
    }
  },
  created() {
    this.getIndexTemplate()
    // this.getLayoutType()
    // this.getLabelList()
    this.getGoodsPage()
    // this.getRootCategoryList()
    this.getPageList()
    this.getGoodsTag()
    this.getFunctionList()
  },
  methods: {

    getFunctionList() {
      this.axios.get('/indexTemplate/getFuncList')
        .then(res => {
          console.log('功能列表==', res)
          if (res.code == 0) {
            this.functionInlet = res.data
          }
        })
    },
    async selectGoodsTagFn(id, disabled) {
      if (!disabled) return
      this.goodsTagList.forEach(item => {
        if (item.id == id) {
          item.selected = !item.selected;
        }
      })
      let list = this.goodsTagList.filter(item => item.selected)
      console.log('选中的标签===', list)
      if (list.length > 0) {
        this.viewData[this.viewIndex].modelDetail.tagList = list.map(item => {
          return {
            id: item.id,
            name: item.name
          }
        })
        let ids = this.viewData[this.viewIndex].modelDetail.tagList.map(item => {
          return item.id
        })
        let goods = await this.getTagGoodsList(ids[0])
        this.viewData[this.viewIndex].modelDetail.tagGoodsList = goods;
        console.log('第一标签商品===', goods)
      } else {
        this.viewData[this.viewIndex].modelDetail.tagGoodsList = []
        this.viewData[this.viewIndex].modelDetail.tagList = []
      }



      // if(ids.length == 0) return

      // console.log(goods)
      console.log('选择的标签ID', this.viewData[this.viewIndex].modelDetail.tagList)
      // tagGoodsList
    },
    async getTagGoodsList(ids) {
      let data = {
        pageNo: 1,
        pageSize: 10,
        tagIds: [ids]
      }
      let res = await this.axios.post('/appIndex/searchGoods', data)
      console.log('根据标签获取商品', res)
      if (res.code == 0) {
        return res.data.list
        // if(res.data.list.length == 0){
        //   this.$message.warning('')
        // }
        //this.viewData[this.viewIndex].modelDetail.tagGoodsList = res.data.list;
      }
    },
    getGoodsTag() {
      let data = {
        status: 1,
        pageNo: 1,
        pageSize: 1000
      }
      this.axios.post('/tagPool/show/pageList', data)
        .then(async res => {
          console.log('商品标签', res)
          if (res.code == 0) {
            res.data.list.forEach(item => {
              item.selected = false
              item.disabled = false
            })
            this.goodsTagList = res.data.list;
            let ids = this.goodsTagList.map(item => {
              return item.id
            })
            let list = await this.getEnableTags(ids)
            console.log('需要标签', list)
            this.goodsTagList.forEach(item => {
              list.forEach(val => {
                if (item.id == val.id) {
                  item.disabled = true
                }
              })
            })
            console.log('对比标签', this.goodsTagList)
          }

        })
    },
    async confirmTag() {
      if (this.tagActiveId) {
        this.viewData[this.viewIndex].modelDetail.labelList[this.tagRowIndex].labelId = this.tagActiveId
        this.nameLabelList.forEach(item => {
          if (item.id == this.tagActiveId) {
            this.viewData[this.viewIndex].modelDetail.labelList[this.tagRowIndex].labelName = item.name
          }
        })
      }
      console.log('哈哈哈', this.tagActiveId)
      if (this.viewData[this.viewIndex].modelType == 9) {
        console.log('名义', this.viewData[this.viewIndex])
        let ids = this.viewData[this.viewIndex].modelDetail.labelList[0].labelId
        let list = await this.getTagGoodsList(ids)
        this.viewData[this.viewIndex].modelDetail.labelList[0].goodsList = list;
        console.log(list)
      }
      // this.getTagGoods(this.tagActiveId)
      this.tagDialog = false;

    },
    getTagGoods(tagId) {
      let data = {
        status: '',
        categoryIds: '',
        tagLevel2: [tagId],
        pageNo: 1,
        pageSize: 4
      }
      this.axios.post('/goods/pageList', data)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            if (this.tagType == 'name' || this.tagType == 'people') {
              this.viewData[this.viewIndex].modelDetail.labelList[this.tagRowIndex].goodsList = res.data.list
            }
            console.log(this.viewData[this.viewIndex].modelDetail.labelList)
          }

        })
    },
    selectTagFn(id) {
      this.tagActiveId = id;
    },
    showTagDialog(viewIndex, index, labelId, type) {

      this.viewIndex = viewIndex;
      this.tagActiveId = labelId;
      this.tagRowIndex = index;
      this.tagType = type;
      // this.viewData[viewIndex].modelDetail.labelList[index].labelId = 
      console.log(labelId)
      this.getLabelType(type)
    },
    getLabelType(type) {
      this.axios.post('/tagPool/filter/categoryList')
        .then(res => {
          console.log('标签飞得更高', res)
          if (res.code == 0) {
            res.data.forEach(item => {
              let dictId;
              if (type == 'name') {
                if (item.dictName.indexOf('名义') > -1) {
                  dictId = item.dictId
                  this.tagPoolList(dictId)
                }
              }
              if (type == 'people') {
                if (item.dictName.indexOf('人群') > -1) {
                  dictId = item.dictId
                  this.tagPoolList(dictId)
                }
              }


            })
          }
        })
    },
    tagPoolList(id) {
      let data = {
        tagId: id,
        pageNo: 1,
        pageSize: 1000
      }
      this.axios.post('/tagPool/filter/pageList', data)
        .then(res => {
          console.log(res)
          this.nameLabelList = res.data.list;
          this.tagDialog = true;
        })
    },
    titleFn() {
      this.modulBox = false;
      console.log('标题设置', this.modulData)
      Object.keys(this.modulData).forEach(item => {
        this.viewData[this.viewIndex][item] = this.modulData[item]
      })
      this.viewData[this.viewIndex].pageId = this.pageId;
      this.viewData[this.viewIndex].pageType = this.pageType;

      this.$forceUpdate()
    },
    showModulSetting(viewIndex, type) {
      this.modulBox = true;
      this.viewIndex = viewIndex;
      let data = {
        title: this.viewData[viewIndex].title,
        subTitle: this.viewData[viewIndex].subTitle,
        btnTitle: this.viewData[viewIndex].btnTitle,
        navType: this.viewData[viewIndex].navType,
        funcName: this.viewData[viewIndex].funcName,
        navUrl: this.viewData[viewIndex].navUrl
      }
      this.modulData = data;
      // this.viewData[viewIndex]
    },
    selectPageType(type) {
      this.pageType = type
      this.searchForm.pageNo = 1;
      this.getPageList()
    },
    selectType(type) {
      this.goodsType = type
      this.goodsPageNo = 1;
      this.getGoodsPage()
    },
    getPageList() {
      let url = '/appIndex/pageList'
      if (this.pageType == 1) {
        url = '/appIndex/pageList'
        this.searchForm.status = true
      } else {
        url = '/marketActivate/pageList'
        this.searchForm.name = this.searchForm.title;
        this.searchForm.status = 1;
      }
      this.axios.post(url, this.searchForm)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.pageList = res.data.list;
            this.pageTotalNum = res.data.totalNum;
          }
        })
    },
    handleSizeChangePage(e) {
      this.searchForm.pageSize = e;
      this.searchForm.pageNo = 1;
      this.getPageList()
    },
    handleCurrentChangePage(e) {
      this.searchForm.pageNo = e;
      this.getPageList()
    },
    handleSizeChangeLabel(e) {
      this.labelPageSize = e;
      this.labelPageNo = 1;
      this.getLabelList()
    },
    handleCurrentChangeLabel(e) {
      this.labelPageNo = e;
      this.getLabelList()
    },
    getLabelList() {
      let data = {
        pageNo: this.labelPageNo,
        pageSize: this.labelPageSize,
        tagName: this.tagName,
        status: true
      }
      this.axios.post('/tags/pageList', data)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.labelList = res.data.list;
            this.labelTotalNum = res.data.totalNum
          }
        })
    },
    getLayoutType() {
      this.axios.get('/sys/index/getLayoutType')
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.classifyType = res.data + '';
            if (this.classifyType == '1') {
              this.functionLeft[2] = '分类类目'
            } else if (this.classifyType == '2') {
              this.functionLeft[2] = '分类标签'
            }
          }
        })
    },
    saveIndexTemplate() {
      console.log(this.viewData)
      let data = {
        id: this.pid,
        modelJsonStr: JSON.stringify(this.viewData),
        type: '1'
      }
      this.axios.post('/indexTemplate/save', data)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.getIndexTemplate()
            this.$message.success('保存成功')
          } else {
            this.$message.warning(res.message)
          }
        })
    },
    async goodsConfirmFn() {
      console.log('选择的商品', this.selectedGoods)
      if (this.selectedGoods.length > 0) {
        this.viewData[this.viewIndex].modelDetail.goodsList = this.viewData[this.viewIndex].modelDetail.goodsList.concat(this.selectedGoods)
        this.viewData[this.viewIndex].modelDetail.goodsList = this.removeArray(this.viewData[this.viewIndex].modelDetail.goodsList, 'itemNo')
        this.viewData[this.viewIndex].modelDetail.idList = this.viewData[this.viewIndex].modelDetail.goodsList.map(item => {
          return item.itemNo
        })
        console.log(await this.getGoodsList(this.viewData[this.viewIndex].modelDetail.idList))
        let list = await this.getGoodsList(this.viewData[this.viewIndex].modelDetail.idList)

        this.$nextTick(() => {
          this.viewData[this.viewIndex].modelDetail.viewGoodsList = list
          console.log(this.viewData)
        })

      }
      this.goodsDialogVisible = false
    },
    showGoodsDialog(viewIndex) {
      this.goodsDialogVisible = true;
      this.viewIndex = viewIndex;
      this.goodsInfo = ''
      this.searchGoods()
    },
    removeArray(arr, key) {
      let temp = [];
      arr.forEach(function (a) {
        var check = temp.every(function (b) {
          return a[key] !== b[key];
        })
        check ? temp.push(a) : ''
      })
      return temp;
    },
    handleSelectionChange(e) {
      this.selectedGoods = e;
    },
    getShowType(e, viewIndex, rowIndex) {
      //console.log(e)showType
      // console.log(,this.viewData[viewIndex])
      //     return
      let changeIndex = Number(this.viewIndex + '')
      this.viewIndex = -1
      rowIndex = rowIndex - 1;

      if (e == 5) {

        if (this.viewData[viewIndex].modelDetail.activityNavList[rowIndex].children) {
          delete this.viewData[viewIndex].modelDetail.activityNavList[rowIndex].children
        }

      }
      if (e == 2 || e == 3) {
        let navModel = {
          navType: 0, //1-功能跳转，2-分类标签，3-商品
          funcName: '无',
          navUrl: '',
          id: null //功能、分类或商品id
        }
        console.log(rowIndex)
        console.log('这是id=', this.viewData[viewIndex].modelDetail.activityNavList)
        // return

        if (e == 2) {
          console.log(this.viewData[viewIndex], '6666')
          let children = [{
            id: this.viewData[viewIndex].modelDetail.activityNavList[rowIndex].id + 10,
            showType: 3,
            imgUrl: '',
            navModel: navModel,
            index: 0
          }]
          this.viewData[viewIndex].modelDetail.activityNavList[rowIndex].children = children;
        } else {
          // rowIndex = rowIndex - 1;
          if (!this.viewData[viewIndex].modelDetail.activityNavList[rowIndex].children || this.viewData[viewIndex].modelDetail.activityNavList[rowIndex].children.length == 0) {
            let data = {
              id: this.viewData[viewIndex].modelDetail.activityNavList[rowIndex].id + 10,
              showType: 3,
              imgUrl: '',
              navModel: navModel,
              index: 0
            }
            let data2 = JSON.parse(JSON.stringify(data))
            data2.id = this.viewData[viewIndex].modelDetail.activityNavList[rowIndex].id + 110
            data2.index = 1;
            this.viewData[viewIndex].modelDetail.activityNavList[rowIndex].children = [data, data2]

          } else {
            let data = {
              id: this.viewData[viewIndex].modelDetail.activityNavList[rowIndex].id + 110,
              showType: 3,
              imgUrl: '',
              navModel: navModel,
              index: 1
            }
            this.viewData[viewIndex].modelDetail.activityNavList[rowIndex].children.push(data)
          }
        }

        // if(!this.viewData[viewIndex].modelDetail.activityNavList[rowIndex + 1] || this.viewData[viewIndex].modelDetail.activityNavList[rowIndex + 1].showType != 3){
        //     this.viewData[viewIndex].modelDetail.activityNavList.splice(rowIndex + 1,0,data)
        // }
      }
      this.viewData[viewIndex].modelDetail.activityNavList = JSON.parse(JSON.stringify(this.viewData[viewIndex].modelDetail.activityNavList))
      this.$forceUpdate()
      this.$nextTick(() => {
        this.viewIndex = changeIndex
      })
      let arr = this.viewData[viewIndex].modelDetail.activityNavList
      console.log(arr)
    },
    addNav(viewIndex, modelType) {
      //modelType==1-搜索功能，2-轮播图，3-分类导航，4-图片导航，5-标题导航，6-活动导航，7-商品导航
      let navModel = {
        navType: 0, //1-功能跳转，2-分类标签，3-商品
        funcName: '无',
        navUrl: '',
        id: null //功能、分类或商品id
      }
      if (modelType == 2) {
        if (this.viewData[this.viewIndex].modelDetail.swiperImageList.length == 10) {
          this.$message.warning('最多只能添加10张图片')
          return
        }
        let data = {
          imgName: '',
          imgUrl: '',
          navModel: navModel
        }
        this.viewData[this.viewIndex].modelDetail.swiperImageList.push(data)
      }
      if (modelType == 3) {
        let data = {
          categoryNavName: '',
          imgUrl: '',
          navModel: navModel
        }
        this.viewData[this.viewIndex].modelDetail.categoryNavList.push(data)
      }
      if (modelType == 4 || modelType == 12) {
        let data = {
          imgUrl: '',
          navModel: navModel
        }
        this.viewData[this.viewIndex].modelDetail.imgList.push(data)
      }
      if (modelType == 13) {
        let data = {
          goods: {},
          navModel: navModel
        }
        this.viewData[this.viewIndex].modelDetail.viewGoodsList.push(data)
      }
      if (modelType == 6 || modelType == 11) {
        let idx = this.viewData[this.viewIndex].modelDetail.activityNavList.length - 1;
        let data = {
          id: this.viewData[this.viewIndex].modelDetail.activityNavList.length > 0 ? this.viewData[this.viewIndex].modelDetail.activityNavList[idx].id + 1 : 1,
          imgUrl: '',
          showType: 5,
          oneLan: 1,
          navModel: navModel
        }
        this.viewData[this.viewIndex].modelDetail.activityNavList.push(data)
      }
      if (modelType == 9 || modelType == 10) {
        let data = {
          labelId: null,
          labelName: '',
          goodsList: []
        }
        if (modelType == 10) {
          data.navModel = navModel;
        }
        this.viewData[this.viewIndex].modelDetail.labelList.push(data)
      }
      this.$forceUpdate()
    },
    getFunctionName(name, url) {
      this.pageName = name;
      this.navUrl = url;
      console.log('nameUrl==', name, url)
    },
    // 校验表单
    checkConfirm() { 
        if (this.functionIndex == 4) {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.confirmFn();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        }else{
            this.confirmFn();
        }
        
    },
    async confirmFn() {
      let funcName = '无';
      let rootCategoryId = '';
      let categoryId = '';
      let goodsSelectedId = '';
      let navUrl = '';
      let goods = {}
      if (this.functionIndex == 0) {
        funcName = '无'
      } else if (this.functionIndex == 1) {
        // { label: '1', name: '消息中心' },
        // { label: '2', name: '佣金管理' },
        // { label: '3', name: '地址管理' },
        // { label: '4', name: '银行卡' },
        // { label: '5', name: '店铺申请' }
        // if (this.functionInletRadio == '1') {
        //   funcName = '消息中心'
        // }
        // if (this.functionInletRadio == '2') {
        //   funcName = '佣金管理'
        // }
        // if (this.functionInletRadio == '3') {
        //   funcName = '地址管理'
        // }
        // if (this.functionInletRadio == '4') {
        //   funcName = '银行卡'
        // }
        // if (this.functionInletRadio == '5') {
        //   funcName = '店铺申请'
        // }
        // if (this.functionInletRadio == '6') {
        //   funcName = '粉丝管理'
        // }
        // if (this.functionInletRadio == '7') {
        //   funcName = '联系客服'
        // }
        // if (this.functionInletRadio == '8') {
        //   funcName = '会员中心'
        // }
        // if (this.functionInletRadio == '9') {
        //   funcName = '优惠券'
        // }
        // if (this.functionInletRadio == '10') {
        //   funcName = '订单中心'
        // }
        funcName = this.pageName;
        navUrl = this.navUrl;
      } else if (this.functionIndex == 2) {
        goodsSelectedId = this.goodsSelectedId;
        this.goodsList.forEach((item) => {
          if (this.goodsSelectedId === item.itemNo) {
            funcName = item.name.substring(0, 8) + '...'
            goods = item
          }
        })
        // funcName = this.pageName;
      } else if (this.functionIndex == 3) {
        this.pageList.forEach((item) => {
          if (this.pageId === item.id) {
            funcName = item.title || item.name
          }
        })
      }else if (this.functionIndex == 4) { 
        funcName = '小程序跳转'
      }
      if (this.viewData[this.viewIndex].modelType == 1) {//搜索框模块
        this.viewData[this.viewIndex].modelDetail.navModel.funcName = funcName;
        this.viewData[this.viewIndex].modelDetail.navModel.navUrl = navUrl;
        this.viewData[this.viewIndex].modelDetail.navModel.navType = this.functionIndex;
        this.viewData[this.viewIndex].modelDetail.navModel.rootCategoryId = rootCategoryId;
        this.viewData[this.viewIndex].modelDetail.navModel.categoryId = categoryId;
        this.viewData[this.viewIndex].modelDetail.navModel.goodsSelectedId = goodsSelectedId;
        this.viewData[this.viewIndex].modelDetail.navModel.functionInletRadio = this.functionInletRadio;
        this.viewData[this.viewIndex].modelDetail.navModel.labelId = this.labelId;
        this.viewData[this.viewIndex].modelDetail.navModel.pageId = this.pageId;
        this.viewData[this.viewIndex].modelDetail.navModel.pageType = this.pageType;
        this.viewData[this.viewIndex].modelDetail.navModel.gId=this.form.gId
        this.viewData[this.viewIndex].modelDetail.navModel.appId=this.form.appId
        this.viewData[this.viewIndex].modelDetail.navModel.appUrl= this.form.appUrl
      }
      if (this.viewData[this.viewIndex].modelType == 2) {//轮播图模块
        this.viewData[this.viewIndex].modelDetail.swiperImageList[this.rowIndex].navModel.funcName = funcName;
        this.viewData[this.viewIndex].modelDetail.swiperImageList[this.rowIndex].navModel.navUrl = navUrl
        this.viewData[this.viewIndex].modelDetail.swiperImageList[this.rowIndex].navModel.navType = this.functionIndex;
        this.viewData[this.viewIndex].modelDetail.swiperImageList[this.rowIndex].navModel.rootCategoryId = rootCategoryId;
        this.viewData[this.viewIndex].modelDetail.swiperImageList[this.rowIndex].navModel.categoryId = categoryId;
        this.viewData[this.viewIndex].modelDetail.swiperImageList[this.rowIndex].navModel.goodsSelectedId = goodsSelectedId;
        this.viewData[this.viewIndex].modelDetail.swiperImageList[this.rowIndex].navModel.functionInletRadio = this.functionInletRadio;
        this.viewData[this.viewIndex].modelDetail.swiperImageList[this.rowIndex].navModel.labelId = this.labelId;
        this.viewData[this.viewIndex].modelDetail.swiperImageList[this.rowIndex].navModel.pageId = this.pageId;
        this.viewData[this.viewIndex].modelDetail.swiperImageList[this.rowIndex].navModel.pageType = this.pageType;
        this.viewData[this.viewIndex].modelDetail.swiperImageList[this.rowIndex].navModel.gId=this.form.gId
        this.viewData[this.viewIndex].modelDetail.swiperImageList[this.rowIndex].navModel.appId=this.form.appId
        this.viewData[this.viewIndex].modelDetail.swiperImageList[this.rowIndex].navModel.appUrl= this.form.appUrl
      }
      if (this.viewData[this.viewIndex].modelType == 3) {//分类导航模块categoryNavList
        console.log('rowIndex', this.rowIndex)
        this.viewData[this.viewIndex].modelDetail.categoryNavList[this.rowIndex].navModel.funcName = funcName;
        this.viewData[this.viewIndex].modelDetail.categoryNavList[this.rowIndex].navModel.navUrl = navUrl
        this.viewData[this.viewIndex].modelDetail.categoryNavList[this.rowIndex].navModel.navType = this.functionIndex;
        this.viewData[this.viewIndex].modelDetail.categoryNavList[this.rowIndex].navModel.rootCategoryId = rootCategoryId;
        this.viewData[this.viewIndex].modelDetail.categoryNavList[this.rowIndex].navModel.categoryId = categoryId;
        this.viewData[this.viewIndex].modelDetail.categoryNavList[this.rowIndex].navModel.goodsSelectedId = goodsSelectedId;
        this.viewData[this.viewIndex].modelDetail.categoryNavList[this.rowIndex].navModel.functionInletRadio = this.functionInletRadio;
        this.viewData[this.viewIndex].modelDetail.categoryNavList[this.rowIndex].navModel.labelId = this.labelId;
        this.viewData[this.viewIndex].modelDetail.categoryNavList[this.rowIndex].navModel.pageId = this.pageId;
        this.viewData[this.viewIndex].modelDetail.categoryNavList[this.rowIndex].navModel.pageType = this.pageType;
        this.viewData[this.viewIndex].modelDetail.categoryNavList[this.rowIndex].navModel.gId=this.form.gId
        this.viewData[this.viewIndex].modelDetail.categoryNavList[this.rowIndex].navModel.appId=this.form.appId
        this.viewData[this.viewIndex].modelDetail.categoryNavList[this.rowIndex].navModel.appUrl= this.form.appUrl
      }
      if (this.viewData[this.viewIndex].modelType == 4 || this.viewData[this.viewIndex].modelType == 12) {//图片导航模块
        console.log('rowIndex', this.rowIndex)
        this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.funcName = funcName;
        this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.navUrl = navUrl;
        this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.navType = this.functionIndex;
        this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.rootCategoryId = rootCategoryId;
        this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.categoryId = categoryId;
        this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.goodsSelectedId = goodsSelectedId;
        this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.functionInletRadio = this.functionInletRadio;
        this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.labelId = this.labelId;
        this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.pageId = this.pageId;
        this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.pageType = this.pageType;
        this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.gId=this.form.gId
        this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.appId=this.form.appId
        this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.appUrl= this.form.appUrl

      }
      if (this.viewData[this.viewIndex].modelType == 5) {//标题导航模块
        this.viewData[this.viewIndex].modelDetail.navModel.funcName = funcName;
        this.viewData[this.viewIndex].modelDetail.navModel.navUrl = navUrl;
        this.viewData[this.viewIndex].modelDetail.navModel.navType = this.functionIndex;
        this.viewData[this.viewIndex].modelDetail.navModel.rootCategoryId = rootCategoryId;
        this.viewData[this.viewIndex].modelDetail.navModel.categoryId = categoryId;
        this.viewData[this.viewIndex].modelDetail.navModel.goodsSelectedId = goodsSelectedId;
        this.viewData[this.viewIndex].modelDetail.navModel.functionInletRadio = this.functionInletRadio;
        this.viewData[this.viewIndex].modelDetail.navModel.labelId = this.labelId;
        this.viewData[this.viewIndex].modelDetail.navModel.pageId = this.pageId;
        this.viewData[this.viewIndex].modelDetail.navModel.pageType = this.pageType;
        this.viewData[this.viewIndex].modelDetail.navModel.gId=this.form.gId
        this.viewData[this.viewIndex].modelDetail.navModel.appId=this.form.appId
        this.viewData[this.viewIndex].modelDetail.navModel.appUrl= this.form.appUrl
      }
      if (this.viewData[this.viewIndex].modelType == 6 || this.viewData[this.viewIndex].modelType == 11) {//活动导航模块
        if (this.activeRow.oneLan == 1) {
          this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.funcName = funcName;
          this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.navUrl = navUrl
          this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.navType = this.functionIndex;
          this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.rootCategoryId = rootCategoryId;
          this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.categoryId = categoryId;
          this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.goodsSelectedId = goodsSelectedId;
          this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.functionInletRadio = this.functionInletRadio;
          this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.labelId = this.labelId;
          this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.pageId = this.pageId;
          this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.pageType = this.pageType;
          this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.gId=this.form.gId
          this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.appId=this.form.appId
          this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.appUrl= this.form.appUrl
        } else {
          console.log('this.activeRow.id==', this.activeRow.id)
          let arr = this.viewData[this.viewIndex].modelDetail.activityNavList.filter(item => {
            return item.children && item.children[this.activeRow.index].id == this.activeRow.id
          })
          console.log('arr==', arr)
          arr[0].children[this.activeRow.index].navModel.funcName = funcName;
          arr[0].children[this.activeRow.index].navModel.navUrl = navUrl;
          arr[0].children[this.activeRow.index].navModel.navType = this.functionIndex;
          arr[0].children[this.activeRow.index].navModel.rootCategoryId = rootCategoryId;
          arr[0].children[this.activeRow.index].navModel.categoryId = categoryId;
          arr[0].children[this.activeRow.index].navModel.goodsSelectedId = goodsSelectedId;
          arr[0].children[this.activeRow.index].navModel.functionInletRadio = this.functionInletRadio;
          arr[0].children[this.activeRow.index].navModel.labelId = this.labelId;
          arr[0].children[this.activeRow.index].navModel.pageId = this.pageId;
          arr[0].children[this.activeRow.index].navModel.pageType = this.pageType;
          arr[0].children[this.activeRow.index].navModel.gId = this.form.gId;
          arr[0].children[this.activeRow.index].navModel.appId = this.form.appId;
          arr[0].children[this.activeRow.index].navModel.appUrl = this.form.appUrl;
        }
      }
      console.log('this.viewData[this.viewIndex].modelType == ', this.viewData[this.viewIndex].modelType, this.rowIndex)
      if (this.viewData[this.viewIndex].modelType == 8 && this.rowIndex != 'title') {//节日送礼导航模块
        this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.funcName = funcName;
        this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.navUrl = navUrl
        this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.navType = this.functionIndex;
        this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.functionInletRadio = this.functionInletRadio;
        this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.labelId = this.labelId;
        this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.pageId = this.pageId;
        this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.pageType = this.pageType;
        this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.goodsSelectedId = goodsSelectedId;
        this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.gId = this.form.gId
        this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.appId = this.form.appId
        this.viewData[this.viewIndex].modelDetail.imgList[this.rowIndex].navModel.appUrl = this.form.appUrl

      }
      if (this.rowIndex == 'title') {
        // viewData.navType = 0; //1-功能跳转，2-分类标签，3-商品
        // viewData.funcName = '无';
        // viewData.navUrl = '';
        console.log('来了吗')
        this.viewData[this.viewIndex].navType = this.functionIndex;
        this.viewData[this.viewIndex].funcName = funcName;
        this.viewData[this.viewIndex].navUrl = navUrl;
        this.viewData[this.viewIndex].goodsSelectedId = goodsSelectedId;
        this.viewData[this.viewIndex].functionInletRadio = this.functionInletRadio
        this.modulData.navType = this.functionIndex;
        this.modulData.funcName = funcName;
        this.modulData.navUrl = navUrl;
        this.modulData.goodsSelectedId = goodsSelectedId;
        this.modulData.functionInletRadio = this.functionInletRadio
      }
      if (this.viewData[this.viewIndex].modelType == 10 && this.rowIndex != 'title') {//人群送礼导航模块
        this.viewData[this.viewIndex].modelDetail.labelList[this.rowIndex].navModel.funcName = funcName;
        this.viewData[this.viewIndex].modelDetail.labelList[this.rowIndex].navModel.navUrl = navUrl;
        this.viewData[this.viewIndex].modelDetail.labelList[this.rowIndex].navModel.navType = this.functionIndex;
        this.viewData[this.viewIndex].modelDetail.labelList[this.rowIndex].navModel.functionInletRadio = this.functionInletRadio;
        this.viewData[this.viewIndex].modelDetail.labelList[this.rowIndex].navModel.goodsSelectedId = goodsSelectedId;
        this.viewData[this.viewIndex].modelDetail.labelList[this.rowIndex].navModel.labelId = this.labelId;
        this.viewData[this.viewIndex].modelDetail.labelList[this.rowIndex].navModel.pageId = this.pageId;
        this.viewData[this.viewIndex].modelDetail.labelList[this.rowIndex].navModel.pageType = this.pageType;
        this.viewData[this.viewIndex].modelDetail.labelList[this.rowIndex].navModel.gId = this.form.gId;
        this.viewData[this.viewIndex].modelDetail.labelList[this.rowIndex].navModel.appId = this.appId;
        this.viewData[this.viewIndex].modelDetail.labelList[this.rowIndex].navModel.appUrl = this.appUrl;
      }
      console.log(this.viewData[this.viewIndex])
      if (this.viewData[this.viewIndex].modelType == 13) {//标题导航模块
        this.viewData[this.viewIndex].modelDetail.viewGoodsList[this.rowIndex].goods = goods
        this.viewData[this.viewIndex].modelDetail.viewGoodsList[this.rowIndex].navModel.funcName = funcName;
        this.viewData[this.viewIndex].modelDetail.viewGoodsList[this.rowIndex].navModel.goodsSelectedId = goodsSelectedId;
        this.viewData[this.viewIndex].modelDetail.viewGoodsList[this.rowIndex].navModel.gId = this.form.gId
        this.viewData[this.viewIndex].modelDetail.viewGoodsList[this.rowIndex].navModel.appId = this.form.appId;
        this.viewData[this.viewIndex].modelDetail.viewGoodsList[this.rowIndex].navModel.appUrl = this.form.appUrl;
        this.viewData[this.viewIndex].modelDetail.idList = this.viewData[this.viewIndex].modelDetail.viewGoodsList.map(item => {
          return item.goods.itemNo
        })
        let list = await this.getGoodsList(this.viewData[this.viewIndex].modelDetail.idList)
        this.$nextTick(() => {
          this.viewData[this.viewIndex].modelDetail.goodsList = list
          console.log(this.viewData)
        })
      }
      this.$forceUpdate()
      // console.log(this.viewData[this.viewIndex].modelDetail)
      this.dialogVisible = false;
      this.$nextTick(() => {
        this.rootCategoryId = null;
        this.categoryId = null;
        this.goodsSelectedId = null;
        this.functionInletRadio = null;
      })
    },
    showDialog(viewIndex, rowIndex, navType, goodsId) {
      this.showGoodsLink = this.viewData[this.viewIndex].modelType !== 13 // 商品排行隐藏小程序跳转
      this.viewIndex = viewIndex;
      if (this.viewData[this.viewIndex].modelType == 6 || this.viewData[this.viewIndex].modelType == 11) {
        this.activeRow = rowIndex;
      } else {
        this.rowIndex = rowIndex;
      }
      console.log('navType==', navType, rowIndex)
      console.log('pageId ======== ',this.viewData[this.viewIndex])
      this.dialogVisible = true;
      this.form.gId= ''
      this.form.appId = ''
      this.form.appUrl = ''
      this.functionIndex = navType
      this.selectedGoods = []
      this.goodsSelectedId = goodsId
      if (navType == 1) {//功能入口
        if (this.viewData[this.viewIndex].modelType == 1) {//轮播图
          this.functionInletRadio = this.viewData[this.viewIndex].modelDetail.navModel.functionInletRadio
        }
        if (this.viewData[this.viewIndex].modelType == 2) {//轮播图
          this.functionInletRadio = this.viewData[this.viewIndex].modelDetail.swiperImageList[rowIndex].navModel.functionInletRadio
        }
        if (this.viewData[this.viewIndex].modelType == 3) {//分类导航
          this.functionInletRadio = this.viewData[this.viewIndex].modelDetail.categoryNavList[rowIndex].navModel.functionInletRadio
        }
        if (this.viewData[this.viewIndex].modelType == 4  || this.viewData[this.viewIndex].modelType == 12) {//图片导航
          this.functionInletRadio = this.viewData[this.viewIndex].modelDetail.imgList[rowIndex].navModel.functionInletRadio
        }
        if (this.viewData[this.viewIndex].modelType == 5) {//标题导航
          this.functionInletRadio = this.viewData[this.viewIndex].modelDetail.navModel.functionInletRadio
        }
        if (this.viewData[this.viewIndex].modelType == 6 || this.viewData[this.viewIndex].modelType == 11) {//活动导航
          console.log(this.viewData[this.viewIndex].modelDetail)
          if (this.activeRow.oneLan == 1) {
            this.functionInletRadio = this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.functionInletRadio
          } else {
            let arr = this.viewData[this.viewIndex].modelDetail.activityNavList.filter(item => {
              return item.children && item.children[this.activeRow.index].id == this.activeRow.id
            })
            console.log('arr==', arr)
            this.functionInletRadio = arr[0].children[this.activeRow.index].navModel.functionInletRadio;
          }

        }
        if (this.rowIndex == 'title') {
          // viewData.navType = 0; //1-功能跳转，2-分类标签，3-商品
          // viewData.funcName = '无';
          // viewData.navUrl = '';
          console.log('来了吗', this.viewData[this.viewIndex])
          this.functionInletRadio = this.viewData[this.viewIndex].functionInletRadio || null;
        }
        if (this.viewData[this.viewIndex].modelType == 8 && this.rowIndex != 'title') {//节日送礼导航
          this.functionInletRadio = this.viewData[this.viewIndex].modelDetail.imgList[rowIndex].navModel.functionInletRadio

        }
        if (this.viewData[this.viewIndex].modelType == 10 && this.rowIndex != 'title') {//节日送礼导航
          this.functionInletRadio = this.viewData[this.viewIndex].modelDetail.labelList[rowIndex].navModel.functionInletRadio

        }

      }
      if (navType == 2) {//分类类目
        console.log(this.viewData[this.viewIndex])
        if (this.viewData[this.viewIndex].modelType == 1) {//搜索框
          if (this.classifyType == '2') {
            this.labelId = this.viewData[this.viewIndex].modelDetail.navModel.labelId || null;
            return
          }
          this.rootCategoryId = this.viewData[this.viewIndex].modelDetail.navModel.rootCategoryId
          this.categoryId = this.viewData[this.viewIndex].modelDetail.navModel.categoryId

        }
        if (this.viewData[this.viewIndex].modelType == 2) {//轮播图
          if (this.classifyType == '2') {
            this.labelId = this.viewData[this.viewIndex].modelDetail.swiperImageList[rowIndex].navModel.labelId || null;
            return
          }
          this.rootCategoryId = this.viewData[this.viewIndex].modelDetail.swiperImageList[rowIndex].navModel.rootCategoryId
          this.categoryId = this.viewData[this.viewIndex].modelDetail.swiperImageList[rowIndex].navModel.categoryId

        }
        if (this.viewData[this.viewIndex].modelType == 3) {//分类导航
          if (this.classifyType == '2') {
            this.labelId = this.viewData[this.viewIndex].modelDetail.categoryNavList[rowIndex].navModel.labelId || null;
            return
          }
          this.categoryId = this.viewData[this.viewIndex].modelDetail.categoryNavList[rowIndex].navModel.categoryId
          this.rootCategoryId = this.viewData[this.viewIndex].modelDetail.categoryNavList[rowIndex].navModel.rootCategoryId

        }
        if (this.viewData[this.viewIndex].modelType == 4 || this.viewData[this.viewIndex].modelType == 12) {//图片导航
          if (this.classifyType == '2') {
            this.labelId = this.viewData[this.viewIndex].modelDetail.imgList[rowIndex].navModel.labelId || null;
            return
          }
          this.categoryId = this.viewData[this.viewIndex].modelDetail.imgList[rowIndex].navModel.categoryId
          this.rootCategoryId = this.viewData[this.viewIndex].modelDetail.imgList[rowIndex].navModel.rootCategoryId

        }
        if (this.viewData[this.viewIndex].modelType == 5) {//标题导航
          if (this.classifyType == '2') {
            this.labelId = this.viewData[this.viewIndex].modelDetail.navModel.labelId || null;
            return
          }
          this.categoryId = this.viewData[this.viewIndex].modelDetail.navModel.categoryId
          this.rootCategoryId = this.viewData[this.viewIndex].modelDetail.navModel.rootCategoryId
        }
        if (this.viewData[this.viewIndex].modelType == 6 || this.viewData[this.viewIndex].modelType == 11) {//活动导航
          console.log('rowIndex==', rowIndex)
          if (this.activeRow.oneLan == 1) {
            console.log(this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1])
            if (this.classifyType == '2') {
              this.labelId = this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.labelId || null;
              return
            }
            this.categoryId = this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.categoryId
            this.rootCategoryId = this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.rootCategoryId
            this.pageId = this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.pageId || null;
            this.pageType = this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.pageType;
          } else {
            console.log('this.activeRow.id==', this.activeRow.id)
            let arr = this.viewData[this.viewIndex].modelDetail.activityNavList.filter(item => {
              return item.children && item.children[this.activeRow.index].id == this.activeRow.id
            })

            console.log('arr==', arr)
            if (this.classifyType == '2') {
              this.labelId = arr[0].children[this.activeRow.index].navModel.labelId || null;
              return
            }
            this.categoryId = arr[0].children[this.activeRow.index].navModel.categoryId;
            this.rootCategoryId = arr[0].children[this.activeRow.index].navModel.rootCategoryId
            this.pageId = arr[0].children[this.activeRow.index].navModel.pageId || null;
            this.pageType = arr[0].children[this.activeRow.index].navModel.pageType;
          }
          // if (this.viewData[this.viewIndex].modelDetail.activityNavList[rowIndex]) {
          //   this.categoryId = this.viewData[this.viewIndex].modelDetail.activityNavList[rowIndex].navModel.categoryId
          //   this.rootCategoryId = this.viewData[this.viewIndex].modelDetail.activityNavList[rowIndex].navModel.rootCategoryId
          // } else {
          //   console.log('5555555', this.viewData[this.viewIndex].modelDetail.activityNavList[rowIndex - 1])
          //   this.categoryId = this.viewData[this.viewIndex].modelDetail.activityNavList[rowIndex - 1].children[0].navModel.categoryId
          //   this.rootCategoryId = this.viewData[this.viewIndex].modelDetail.activityNavList[rowIndex - 1].children[0].navModel.rootCategoryId
          // }

        }

        if (this.viewData[this.viewIndex].modelType == 8) {//节日送礼导航
          if (this.classifyType == '2') {
            this.labelId = this.viewData[this.viewIndex].modelDetail.imgList[rowIndex].navModel.labelId || null;
            return
          }
          this.categoryId = this.viewData[this.viewIndex].modelDetail.imgList[rowIndex].navModel.categoryId
          this.rootCategoryId = this.viewData[this.viewIndex].modelDetail.imgList[rowIndex].navModel.rootCategoryId
        }
        if (this.viewData[this.viewIndex].modelType == 10) {//节日送礼导航
          if (this.classifyType == '2') {
            this.labelId = this.viewData[this.viewIndex].modelDetail.labelList[rowIndex].navModel.labelId || null;
            return
          }
          this.categoryId = this.viewData[this.viewIndex].modelDetail.labelList[rowIndex].navModel.categoryId
          this.rootCategoryId = this.viewData[this.viewIndex].modelDetail.labelList[rowIndex].navModel.rootCategoryId
        }
        this.searchCate()
      }
      if (navType == 3) {
        if (this.viewData[this.viewIndex].modelType == 1) {//搜索框
          this.pageId = this.viewData[this.viewIndex].modelDetail.navModel.pageId;
          this.pageType = this.viewData[this.viewIndex].modelDetail.navModel.pageType;
        }
        if (this.viewData[this.viewIndex].modelType == 2) {//轮播图
          this.pageId = this.viewData[this.viewIndex].modelDetail.swiperImageList[rowIndex].navModel.pageId || null;
          this.pageType = this.viewData[this.viewIndex].modelDetail.swiperImageList[rowIndex].navModel.pageType || null;
        }
        if (this.viewData[this.viewIndex].modelType == 3) {//分类导航
          this.pageId = this.viewData[this.viewIndex].modelDetail.categoryNavList[rowIndex].navModel.pageId || null;
          this.pageType = this.viewData[this.viewIndex].modelDetail.categoryNavList[rowIndex].navModel.pageType || null;
        }
        if (this.viewData[this.viewIndex].modelType == 4 || this.viewData[this.viewIndex].modelType == 12) {//图片导航
          this.pageId = this.viewData[this.viewIndex].modelDetail.imgList[rowIndex].navModel.pageId || null;
          this.pageType = this.viewData[this.viewIndex].modelDetail.imgList[rowIndex].navModel.pageType || null;
          console.log('页面设置==', this.pageId, this.pageType)
        }
        if (this.viewData[this.viewIndex].modelType == 5) {//标题导航
          this.pageId = this.viewData[this.viewIndex].modelDetail.navModel.pageId || null;
          this.pageType = this.viewData[this.viewIndex].modelDetail.navModel.pageType || null;
        }
        if (this.viewData[this.viewIndex].modelType == 6 || this.viewData[this.viewIndex].modelType == 11) {//活动导航
          if (this.activeRow.oneLan == 1) {
            // alert(this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.pageType)
            this.pageId = this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.pageId || null;
            this.pageType = this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.pageType;
          } else {
            // alert(this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.pageType,44)
            console.log('this.activeRow.id==', this.activeRow.id)
            let arr = this.viewData[this.viewIndex].modelDetail.activityNavList.filter(item => {
              return item.children && item.children[this.activeRow.index].id == this.activeRow.id
            })

            this.pageId = arr[0].children[this.activeRow.index].navModel.pageId || null;
            this.pageType = arr[0].children[this.activeRow.index].navModel.pageType;
          }
          this.searchForm.pageNo = 1;
          this.getPageList()
        }
        if (this.rowIndex == 'title') {
          // viewData.navType = 0; //1-功能跳转，2-分类标签，3-商品
          // viewData.funcName = '无';
          // viewData.navUrl = '';
          console.log('来了吗', this.viewData[this.viewIndex])
          this.pageId = this.viewData[this.viewIndex].pageId || null;
          this.pageType = this.viewData[this.viewIndex].pageType || 1;
        }
        console.log('this.viewData[this.viewIndex].modelDetail=== pageType', this.viewData[this.viewIndex].modelDetail)
        if (this.viewData[this.viewIndex].modelType == 8 && this.rowIndex != 'title') {//节日送礼导航
          this.pageId = this.viewData[this.viewIndex].modelDetail.imgList[rowIndex].navModel.pageId || null;
          this.pageType = this.viewData[this.viewIndex].modelDetail.imgList[rowIndex].navModel.pageType || 1;
          // this.searchForm.pageNo = 1;
          // this.getPageList()
        }
        if (this.viewData[this.viewIndex].modelType == 10 && this.rowIndex != 'title') {//节日送礼导航
          this.pageId = this.viewData[this.viewIndex].modelDetail.labelList[rowIndex].navModel.pageId || null;
          this.pageType = this.viewData[this.viewIndex].modelDetail.labelList[rowIndex].navModel.pageType || 1;
          // this.searchForm.pageNo = 1;
          // this.getPageList()
        }
        this.searchForm.pageNo = 1;
        this.getPageList()
      }
      if (navType == 4) { // 小程序跳转
        this.$nextTick(()=>{
          this.$refs.form.clearValidate()
        })
        if (this.viewData[this.viewIndex].modelType == 1) {//搜索框
          this.form.gId = this.viewData[this.viewIndex].modelDetail.navModel.gId;
          this.form.appId = this.viewData[this.viewIndex].modelDetail.navModel.appId;
          this.form.appUrl = this.viewData[this.viewIndex].modelDetail.navModel.appUrl;
        }
        if (this.viewData[this.viewIndex].modelType == 2) {//轮播图
          this.form.gId = this.viewData[this.viewIndex].modelDetail.swiperImageList[rowIndex].navModel.gId
          this.form.appId = this.viewData[this.viewIndex].modelDetail.swiperImageList[rowIndex].navModel.appId
          this.form.appUrl = this.viewData[this.viewIndex].modelDetail.swiperImageList[rowIndex].navModel.appUrl
        }
        if (this.viewData[this.viewIndex].modelType == 3) {//分类导航
          this.form.gId = this.viewData[this.viewIndex].modelDetail.categoryNavList[rowIndex].navModel.gId
          this.form.appId = this.viewData[this.viewIndex].modelDetail.categoryNavList[rowIndex].navModel.appId
          this.form.appUrl = this.viewData[this.viewIndex].modelDetail.categoryNavList[rowIndex].navModel.appUrl
        }
        if (this.viewData[this.viewIndex].modelType == 4 || this.viewData[this.viewIndex].modelType == 12) {//图片导航
          this.form.gId = this.viewData[this.viewIndex].modelDetail.imgList[rowIndex].navModel.gId
          this.form.appId = this.viewData[this.viewIndex].modelDetail.imgList[rowIndex].navModel.appId
          this.form.appUrl = this.viewData[this.viewIndex].modelDetail.imgList[rowIndex].navModel.appUrl
        }
        if (this.viewData[this.viewIndex].modelType == 5) {//标题导航
          this.form.gId = this.viewData[this.viewIndex].modelDetail.navModel.gId
          this.form.appId = this.viewData[this.viewIndex].modelDetail.navModel.appId
          this.form.appUrl = this.viewData[this.viewIndex].modelDetail.navModel.appUrl
        }
        if (this.viewData[this.viewIndex].modelType == 6 || this.viewData[this.viewIndex].modelType == 11) {//活动导航
          if (this.activeRow.oneLan == 1) {
            this.form.gId = this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.gId
            this.form.appId = this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.appId
            this.form.appUrl = this.viewData[this.viewIndex].modelDetail.activityNavList[this.activeRow.id - 1].navModel.appUrl
          } else {
            let arr = this.viewData[this.viewIndex].modelDetail.activityNavList.filter(item => {
              return item.children && item.children[this.activeRow.index].id == this.activeRow.id
            })
            this.form.gId = arr[0].children[this.activeRow.index].navModel.gId
            this.form.appId = arr[0].children[this.activeRow.index].navModel.appId
            this.form.appUrl = arr[0].children[this.activeRow.index].navModel.appUrl
          }
          this.searchForm.pageNo = 1;
          this.getPageList()
        }
        if (this.rowIndex == 'title') {
          // viewData.navType = 0; //1-功能跳转，2-分类标签，3-商品
          // viewData.funcName = '无';
          // viewData.navUrl = '';
          console.log('来了吗', this.viewData[this.viewIndex])
          this.pageId = this.viewData[this.viewIndex].pageId || null;
          this.pageType = this.viewData[this.viewIndex].pageType || 1;
        }
        console.log('this.viewData[this.viewIndex].modelDetail=== pageType', this.viewData[this.viewIndex].modelDetail)
        if (this.viewData[this.viewIndex].modelType == 8 && this.rowIndex != 'title') {//节日送礼导航
          this.form.gId = this.viewData[this.viewIndex].modelDetail.imgList[rowIndex].navModel.gId
          this.form.appId = this.viewData[this.viewIndex].modelDetail.imgList[rowIndex].navModel.appId
          this.form.appUrl = this.viewData[this.viewIndex].modelDetail.imgList[rowIndex].navModel.appUrl
          // this.searchForm.pageNo = 1;
          // this.getPageList()
        }
        if (this.viewData[this.viewIndex].modelType == 10 && this.rowIndex != 'title') {//节日送礼导航
          this.form.gId = this.viewData[this.viewIndex].modelDetail.labelList[rowIndex].navModel.gId
          this.form.appId = this.viewData[this.viewIndex].modelDetail.labelList[rowIndex].navModel.appId
          this.form.appUrl = this.viewData[this.viewIndex].modelDetail.labelList[rowIndex].navModel.appUrl
          // this.searchForm.pageNo = 1;
          // this.getPageList()
        }
        this.searchForm.pageNo = 1;
        this.getPageList()
      }
      console.log('>>',this.form)
      this.goodsPageNo = 1
      // console.log(goodsId)
      let data = {
        pageNo: this.goodsPageNo,
        pageSize: this.goodsPageSize,
        selectedId: this.goodsSelectedId,
        goodsInfo: this.goodsInfo,
        goodsType: this.goodsType
      }
      this.axios.post('/goods/GoodsOrGiftPageListForSelect', data)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.goodsList = res.data.list;
            this.goodsList.forEach((item) => {
              if (goodsId === item.goodsId) {
                this.getGoodsName(item.goodsName)
              }
            })
          }
        })
      // this.goodsList.forEach((item) => {
      //   if (goodsId === item.goodsId) {
      //     this.getGoodsName(item.goodsName)
      //   }
      // })
      this.$forceUpdate()

    },
    getImage(e, viewIndex, idx) {
      console.log(e, viewIndex, idx)
      if (this.viewData[viewIndex].modelType == 2) {//轮播图模块
        this.viewData[viewIndex].modelDetail.swiperImageList[idx].imgUrl = e;
      }
      if (this.viewData[viewIndex].modelType == 3) {//分类导航模块
        this.viewData[viewIndex].modelDetail.categoryNavList[idx].imgUrl = e;
      }
      if (this.viewData[viewIndex].modelType == 4 || this.viewData[this.viewIndex].modelType == 12) {//图片导航模块
        this.viewData[viewIndex].modelDetail.imgList[idx].imgUrl = e;
      }
      if (this.viewData[viewIndex].modelType == 6 || this.viewData[viewIndex].modelType == 11) {//活动导航模块

        if (idx.oneLan == 1) {
          this.viewData[viewIndex].modelDetail.activityNavList[idx.id - 1].imgUrl = e;
        } else {
          let gg = Number(((idx.id - 1) + '').slice(-1))
          console.log(444, idx, gg, this.viewData[viewIndex].modelDetail.activityNavList)
          let arr;
          if (this.viewData[viewIndex].modelDetail.activityNavList[gg].children.length == 1) {
            console.log(111, arr)
            arr = this.viewData[viewIndex].modelDetail.activityNavList.filter(item => {
              return item.children && item.children[0].id == idx.id
            })

          } else {
            console.log('的封疆大吏==')
            arr = this.viewData[viewIndex].modelDetail.activityNavList.filter(item => {
              return item.children && item.children[idx.index].id == idx.id
            })
          }

          console.log(arr)
          // 
          if (arr[0].children.length == 1) {
            arr[0].children[0].imgUrl = e;
          } else {
            if (idx.index == 0) {
              console.log('这是111')
              arr[0].children[0].imgUrl = e;

            } else {
              arr[0].children[1].imgUrl = e;
              console.log('这是2222')
            }
          }


        }

      }
      if (this.viewData[viewIndex].modelType == 8) {//节日送礼导航模块
        this.viewData[viewIndex].modelDetail.imgList[idx].imgUrl = e;
      }
      this.imageUrl = e;
      console.log(this.viewData)
      this.$forceUpdate()
    },
    getGoodsName(name) {
      console.log(name, '------------')
      if (name != undefined) {
        this.pageName = name.substring(0, 8) + '...'
      }
      // this.pageName = name.substring(0, 8) + '...'
    },
    swicthCate(id, name) {
      this.pageName = name;
    },
    swicthRootCate(id, name) {
      this.rootCategoryId = id;
      this.catePageNo = 1;
      this.getCategoryList()
    },
    handleSizeChangecate(e) {
      this.catePageSize = e;
      this.catePageNo = 1;
      this.getCategoryList()
    },
    handleCurrentChangecate(e) {
      this.catePageNo = e;
      this.getCategoryList()
    },
    //获取一级分类列表
    getRootCategoryList() {
      this.axios.get('/sys/index/getRootCategoryList?selectedId=' + this.rootCategoryId)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            let list = res.data;
            let idx = list.findIndex(item => item.selected)
            this.rootCategoryId = this.rootCategoryId ? this.rootCategoryId : list[0].id;
            this.rootCategory = list;
            this.getCategoryList()
          }
        })
    },
    searchCate() {
      this.catePageNo = 1;
      this.getCategoryList()
    },
    //获取二级分类列个表
    getCategoryList() {
      let data = {
        pageNo: this.catePageNo,
        pageSize: this.catePageSize,
        parentId: this.rootCategoryId,
        selectedId: this.categoryId,
        categoryName: this.categoryName
      }
      this.axios.post('/sys/index/getCategoryList', data)
        .then(res => {
          console.log('555', res)
          let list = res.data.list;
          let idx = list.findIndex(item => item.selected)
          if (idx > -1) {
            this.categoryId = list[idx].id;
          }
          this.category = list;
          this.cateTotalNum = res.data.totalNum;
          console.log(this.category)
        })
    },
    handleSizeChange(e) {
      this.goodsPageNo = 1;
      this.goodsPageSize = e;
      this.getGoodsPage()
    },
    handleCurrentChange(e) {
      this.goodsPageNo = e;
      this.getGoodsPage()
    },
    searchGoods() {
      this.goodsPageNo = 1;
      this.getGoodsPage()
    },
    //获取商品列表
    getGoodsPage() {
      let data = {
        pageNo: this.goodsPageNo,
        pageSize: this.goodsPageSize,
        selectedId: '',
        goodsInfo: this.goodsInfo,
        goodsType: this.goodsType
      }
      this.axios.post('/goods/GoodsOrGiftPageListForSelect', data)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.goodsList = res.data.list;
            this.goodsTotalNum = res.data.totalNum;
            let list = []
            //遍历表格的数据，再遍历需要在表格中反显的数据，两者的id一致
            if (this.viewData.length == 0) {
              return
            }
            console.log(this.viewData[this.viewIndex].modelDetail)
            if (this.viewData[this.viewIndex].modelDetail && this.viewData[this.viewIndex].modelDetail.goodsList) {
              this.goodsList.forEach((item) => {
                this.viewData[this.viewIndex].modelDetail.goodsList.forEach(val => {
                  if (val.goodsId === item.goodsId) {
                    // 把判断出来的默认表格数据push到创建的数组中
                    list.push(item)
                  }
                })
              })
              console.log('选中的数组', list)
              if (list.length > 0) {
                //再遍历数组，将数据放入方法中
                this.$nextTick(() => {
                  list.forEach((row) => {
                    this.$refs.goodsTable.toggleRowSelection(row)
                  })
                })

              }
            }

          }
        })
    },
    // 获取首页数据
    getIndexTemplate() {
      let data = {
        type: '1'
      }
      this.axios.post('/indexTemplate/get', data)
        .then(res => {
          console.log(res)
          if (res.code === 0) {
            this.pid = res.data.id;
            let modelJson = JSON.parse(res.data.modelJsonStr)


            modelJson.forEach(async item => {
              if (item.modelType == 1) {
                let navModel = {
                  navType: 0, //1-功能跳转，2-分类标签，3-商品
                  funcName: '无',
                  navUrl: '',
                  id: null //功能、分类或商品id
                }
                if (!item.modelDetail.navName) {
                  let data = {
                    navName: '',
                    navModel: navModel
                  }
                  item.modelDetail = data
                }
              }
              if (item.modelType == 7) {
                console.log('商品模块', item.modelDetail)
                if (item.modelDetail.idList && item.modelDetail.idList.length > 0) {
                  let goodsList = await this.getGoodsList(item.modelDetail.idList)
                  console.log('这是商品', goodsList)
                  item.modelDetail.viewGoodsList = goodsList;
                  item.modelDetail.idList = goodsList.map(i => {
                    return i.itemNo
                  })
                }
                if (item.modelDetail.goodsType == 2) {
                  let tagIds = item.modelDetail.tagList.map(i => {
                    return i.id
                  })
                  item.modelDetail.tagList = await this.getEnableTags(tagIds)
                  item.modelDetail.tagList.forEach((t, i) => {
                    this.goodsTagList.forEach((g, d) => {
                      if (t.id == g.id) {
                        g.selected = true
                      }
                    })
                  })
                  console.log('标签-==', this.goodsTagList)
                  // setTimeout(()=>{

                  // },2000)

                }
              }
              if (item.modelType == 2) {
                item.height = item.height ? item.height : '';
                item.radioHeight = item.radioHeight ? item.radioHeight : '1'
              }
              if (item.modelType == 6 || item.modelType == 11) {
                // item.activeName
                console.log('活动===', item)
                item.modelDetail.activityNavList.forEach(acItem => {
                  acItem.navModel.activeName = acItem.navModel.activeName ? acItem.navModel.activeName : '';
                  if (acItem.children && acItem.children.length > 0) {
                    acItem.children.forEach(chil => {
                      chil.navModel.activeName = chil.navModel.activeName ? chil.navModel.activeName : '';
                    })
                  }
                })
              }
              if (item.modelType == 8) {
                item.modelDetail.imgList.forEach((itemx, indexx) => {
                  let date1 = new Date(itemx.festivalDate)
                  let date2 = new Date()
                  let ggg = date1 - date2

                  console.log('什么日子噶=--', ggg)
                  if (ggg < 0) {
                    itemx.days = 0
                  } else {
                    const diffTime = Math.abs(date1 - date2);
                    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                    itemx.days = diffDays //+ 1
                  }

                })
              }
              if (item.modelType == 9) {
                let ids = item.modelDetail.labelList[0].labelId
                let list = await this.getTagGoodsList(ids)
                item.modelDetail.labelList[0].goodsList = list;
                console.log(list)
              }
              if (item.modelType == 10) {
                let ids = item.modelDetail.labelList[0].labelId
                let list = await this.getTagGoodsList(ids)
                item.modelDetail.labelList[0].goodsList = list;
                console.log(list)
              }
              item.margin = item.margin ? item.margin : ''
            })
            this.viewData = modelJson;
            this.$forceUpdate()
            console.log(modelJson)
          }
        })
    },
    async getEnableTags(ids) {
      let res = await this.axios.get('/appIndex/getEnableTags?tagIds=' + ids)
      console.log('过滤标签==', res)
      if (res.code == 0) {
        return res.data
      } else {
        return []
      }
    },
    //根据id获取商品
    async getGoodsList(ids) {
      let res = await this.axios.post('/goods/findGoodsByGoodsNos', { goodsNos: ids })
      console.log(res)
      if (res.code == 0) {
        return res.data
      }
    },
    //节日送礼节日选择
    getDateChange(e, viewIndex, idx) {
      console.log(e)
      let list = this.viewData[viewIndex].modelDetail.imgList;
      let date1 = new Date(e)
      let date2 = new Date()
      const diffTime = Math.abs(date1 - date2);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      list[idx].days = diffDays
      console.log(diffDays)
    },
    //表格操作
    async toTableDown(viewIndex, idx) {
      console.log(this.viewData[viewIndex].modelDetail)
      let array = []
      if (this.viewData[viewIndex].modelType == 2) {
        array = this.viewData[viewIndex].modelDetail.swiperImageList;
      }
      if (this.viewData[viewIndex].modelType == 3) {
        array = this.viewData[viewIndex].modelDetail.categoryNavList;
      }
      if (this.viewData[viewIndex].modelType == 4) {
        array = this.viewData[viewIndex].modelDetail.imgList;
      }
      if (this.viewData[viewIndex].modelType == 6 || this.viewData[viewIndex].modelType == 11) {
        idx = idx - 1;
        array = this.viewData[viewIndex].modelDetail.activityNavList;
      }
      if (this.viewData[viewIndex].modelType == 7) {
        array = this.viewData[viewIndex].modelDetail.goodsList;
      }
      if (this.viewData[viewIndex].modelType == 8) {
        array = this.viewData[viewIndex].modelDetail.imgList;
      }
      if (this.viewData[viewIndex].modelType == 9) {
        array = this.viewData[viewIndex].modelDetail.labelList;
      }
      if (this.viewData[viewIndex].modelType == 10) {
        array = this.viewData[viewIndex].modelDetail.labelList;
      }
      if (this.viewData[viewIndex].modelType == 12) {
        array = this.viewData[viewIndex].modelDetail.imgList;
      }
      if (this.viewData[viewIndex].modelType == 13) {
        array = this.viewData[viewIndex].modelDetail.viewGoodsList;
      }
      array.splice(idx + 1, 1, ...array.splice(idx, 1, array[idx + 1]));
      if (this.viewData[viewIndex].modelType == 6 || this.viewData[viewIndex].modelType == 11) {
        array[idx].id = array[idx].id - 1;
        array[idx + 1].id = array[idx + 1].id + 1
      }
      if (this.viewData[viewIndex].modelType == 7) {
        this.viewData[viewIndex].modelDetail.idList = this.viewData[viewIndex].modelDetail.goodsList.map(item => {
          return item.itemNo
        })
      }
      console.log(this.viewData[viewIndex].modelType)
      if (this.viewData[viewIndex].modelType == 9) {
        console.log('名义', this.viewData[viewIndex])
        let ids = this.viewData[viewIndex].modelDetail.labelList[0].labelId
        let list = await this.getTagGoodsList(ids)
        this.viewData[viewIndex].modelDetail.labelList[0].goodsList = list;
        console.log(list)
      }
      if (this.viewData[viewIndex].modelType == 10) {
        console.log('名义', this.viewData[viewIndex])
        let ids = this.viewData[viewIndex].modelDetail.labelList[0].labelId
        let list = await this.getTagGoodsList(ids)
        this.viewData[viewIndex].modelDetail.labelList[0].goodsList = list;
        console.log(list)
      }
      if (this.viewData[viewIndex].modelType == 13) {
        this.viewData[viewIndex].modelDetail.idList = this.viewData[viewIndex].modelDetail.viewGoodsList.map(item => {
          return item.goods.itemNo
        })
        let list = await this.getGoodsList(this.viewData[this.viewIndex].modelDetail.idList)
        this.$nextTick(() => {
          this.viewData[viewIndex].modelDetail.goodsList = list
          console.log(this.viewData)
        })
      }
      // this.viewData[viewIndex] = JSON.parse(JSON.stringify(this.viewData[viewIndex]))
      // this.$forceUpdate()

    },
    async toTabelUp(viewIndex, idx) {
      let array = []
      if (this.viewData[viewIndex].modelType == 2) {
        array = this.viewData[viewIndex].modelDetail.swiperImageList;
      }
      if (this.viewData[viewIndex].modelType == 3) {
        array = this.viewData[viewIndex].modelDetail.categoryNavList;
      }
      if (this.viewData[viewIndex].modelType == 4) {
        array = this.viewData[viewIndex].modelDetail.imgList;
      }
      if (this.viewData[viewIndex].modelType == 6 || this.viewData[viewIndex].modelType == 11) {
        idx = idx - 1;
        array = this.viewData[viewIndex].modelDetail.activityNavList;
      }
      if (this.viewData[viewIndex].modelType == 7) {
        array = this.viewData[viewIndex].modelDetail.goodsList;
      }
      if (this.viewData[viewIndex].modelType == 8) {
        array = this.viewData[viewIndex].modelDetail.imgList;
      }
      if (this.viewData[viewIndex].modelType == 9) {
        array = this.viewData[viewIndex].modelDetail.labelList;
      }
      if (this.viewData[viewIndex].modelType == 10) {
        array = this.viewData[viewIndex].modelDetail.labelList;
      }
      if (this.viewData[viewIndex].modelType == 12) {
        array = this.viewData[viewIndex].modelDetail.imgList;
      }
      if (this.viewData[viewIndex].modelType == 13) {
        array = this.viewData[viewIndex].modelDetail.viewGoodsList;
      }
      array.splice(idx, 1, ...array.splice(idx - 1, 1, array[idx]));
      if (this.viewData[viewIndex].modelType == 6 || this.viewData[viewIndex].modelType == 11) {
        array[idx].id = array[idx].id + 1;
        array[idx - 1].id = array[idx - 1].id - 1
      }
      if (this.viewData[viewIndex].modelType == 7) {
        this.viewData[viewIndex].modelDetail.idList = this.viewData[viewIndex].modelDetail.goodsList.map(item => {
          return item.itemNo
        })
      }
      if (this.viewData[viewIndex].modelType == 9) {
        console.log('名义', this.viewData[viewIndex])
        let ids = this.viewData[viewIndex].modelDetail.labelList[0].labelId
        let list = await this.getTagGoodsList(ids)
        this.viewData[viewIndex].modelDetail.labelList[0].goodsList = list;
        console.log(list)
      }
      if (this.viewData[viewIndex].modelType == 10) {
        console.log('名义', this.viewData[viewIndex])
        let ids = this.viewData[viewIndex].modelDetail.labelList[0].labelId
        let list = await this.getTagGoodsList(ids)
        this.viewData[viewIndex].modelDetail.labelList[0].goodsList = list;
        console.log(list)
      }
      if (this.viewData[viewIndex].modelType == 13) {
        this.viewData[viewIndex].modelDetail.idList = this.viewData[viewIndex].modelDetail.viewGoodsList.map(item => {
          return item.goods.itemNo
        })
        let list = await this.getGoodsList(this.viewData[this.viewIndex].modelDetail.idList)
        this.$nextTick(() => {
          this.viewData[viewIndex].modelDetail.goodsList = list
          console.log(this.viewData)
        })
      }
    },
    tableDel(viewIndex, idx, row, index) {
      let array = []
      if (this.viewData[viewIndex].modelType == 2) {
        array = this.viewData[viewIndex].modelDetail.swiperImageList;
      }
      if (this.viewData[viewIndex].modelType == 3) {
        array = this.viewData[viewIndex].modelDetail.categoryNavList;
      }
      if (this.viewData[viewIndex].modelType == 4) {
        array = this.viewData[viewIndex].modelDetail.imgList;
      }
      if (this.viewData[viewIndex].modelType == 6 || this.viewData[viewIndex].modelType == 11) {
        console.log('index=====', index)
        // if (children) {
        idx = idx - 1;
        // }

        array = this.viewData[viewIndex].modelDetail.activityNavList;
      }
      if (this.viewData[viewIndex].modelType == 7) {
        array = this.viewData[viewIndex].modelDetail.goodsList;
      }
      if (this.viewData[viewIndex].modelType == 9) {
        array = this.viewData[viewIndex].modelDetail.labelList;
      }
      if (this.viewData[viewIndex].modelType == 10) {
        array = this.viewData[viewIndex].modelDetail.labelList;
      }
      if (this.viewData[viewIndex].modelType == 12) {
        array = this.viewData[viewIndex].modelDetail.imgList;
      }
      if (this.viewData[viewIndex].modelType == 13) {
        array = this.viewData[viewIndex].modelDetail.viewGoodsList;
      }
      console.log(this.viewData[viewIndex].modelDetail.activityNavList, '1111', row)
      this.$confirm('是否确认删除？删除后不可恢复数据！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        if (this.viewData[viewIndex].modelType == 6 || this.viewData[viewIndex].modelType == 11) {
          console.log(row)
          if (row.oneLan == 1) {
            console.log('大是大非看', array)
            array.splice(idx, 1)
          } else {
            console.log(444, '===', idx)
            // return
            // if(this.viewData[viewIndex].modelDetail.activityNavList)
            let arr = this.viewData[viewIndex].modelDetail.activityNavList.filter(item => {
              return item.children && item.children[row.index].id == row.id
            })
            console.log(arr)
            // return

            if (row.index == 0) {
              if (arr[0].children.length == 1) {
                delete arr[0].children
                arr[0].showType = 5;
              } else {
                arr[0].children.splice(0, 1)
                arr[0].showType = 2;
              }

            } else {
              arr[0].children.splice(1, 1)
              arr[0].showType = 2;
            }
            if (arr[0].children && arr[0].children.length > 0) {
              arr[0].children[0].index = 0
            }

          }
          // if(!children){
          //     console.log(34444)

          // }else{


          // }

          // console.log('children',children,idx)
          this.viewData[viewIndex].modelDetail.activityNavList.forEach((item, index) => {
            item.id = index + 1;
            if (item.children) {
              item.children.forEach((itemx, indexx) => {
                if (indexx == 0) {
                  itemx.id = item.id + 10
                } else {
                  itemx.id = item.id + 110
                }

              })
            }
          })
          this.viewData[viewIndex].modelDetail.activityNavList = JSON.parse(JSON.stringify(this.viewData[viewIndex].modelDetail.activityNavList))
          console.log(this.viewData[viewIndex].modelDetail.activityNavList)
          return
        }
        if (!(this.viewData[viewIndex].modelType == 6 || this.viewData[viewIndex].modelType == 11)) {
          console.log(777777777)
          array.splice(idx, 1)
        }
        if (this.viewData[viewIndex].modelType == 7) {
          this.viewData[viewIndex].modelDetail.idList = this.viewData[viewIndex].modelDetail.goodsList.map(item => {
            return item.itemNo
          })
        }
        if (this.viewData[viewIndex].modelType == 9) {
          console.log('名义', this.viewData[viewIndex])
          let ids = this.viewData[viewIndex].modelDetail.labelList[0].labelId
          let list = await this.getTagGoodsList(ids)
          this.viewData[viewIndex].modelDetail.labelList[0].goodsList = list;
          console.log(list)
        }
        if (this.viewData[viewIndex].modelType == 10) {
          console.log('名义', this.viewData[viewIndex])
          let ids = this.viewData[viewIndex].modelDetail.labelList[0].labelId
          let list = await this.getTagGoodsList(ids)
          this.viewData[viewIndex].modelDetail.labelList[0].goodsList = list;
          console.log(list)
        }
        if (this.viewData[viewIndex].modelType == 13) {
          this.viewData[viewIndex].modelDetail.idList = this.viewData[viewIndex].modelDetail.viewGoodsList.map(item => {
            return item.goods.itemNo
          })
          let list = await this.getGoodsList(this.viewData[this.viewIndex].modelDetail.idList)
          this.$nextTick(() => {
            this.viewData[viewIndex].modelDetail.goodsList = list
            console.log(this.viewData)
          })
        }
      }).catch(() => {

      });

    },
    // 模块操作条
    toDown(idx) {
      let array = this.viewData;
      array.splice(idx + 1, 1, ...array.splice(idx, 1, array[idx + 1]));
      setTimeout(() => {
        this.viewIndex = idx + 1;
        this.toggleBar(idx + 1)
      }, 200)

    },
    toUp(idx) {
      let array = this.viewData;
      array.splice(idx, 1, ...array.splice(idx - 1, 1, array[idx]));
      setTimeout(() => {
        this.viewIndex = idx - 1;
        this.toggleBar(idx - 1)
      }, 200)

    },
    toEdit(idx) {
      this.viewIndex = idx;
    },
    toDel(idx) {
      console.log(idx)
      this.delDialogVisible = true;
      this.delIndex = idx;
    },
    deleteViewFn() {
      this.viewData.splice(this.delIndex, 1)
      if (this.delIndex > 0) {
        this.viewIndex = this.delIndex - 1;
      } else {
        this.viewIndex = 0
      }

      console.log(this.viewData)
      this.delDialogVisible = false;
      this.$forceUpdate()
    },
    //鼠标点击模块
    handleView(idx) {
      this.viewIndex = idx;
      console.log(this.viewData[idx])
      if (this.viewData[idx].modelType == 6 || this.viewData[idx].modelType == 11) {
        setTimeout(() => {
          this.expendAll = true
        }, 500)
      } else {
        this.expendAll = false
      }
      this.toggleBar(idx)
      this.$forceUpdate()
    },
    toggleBar(idx) {
      this.viewData.forEach((item, index) => {
        if (index == idx) {
          item.showBar1 = true;
          item.showBar2 = true;
        } else {
          item.showBar1 = false;
          item.showBar2 = false;
        }
      })
      this.$forceUpdate()
    },
    //鼠标经过事件
    handleCloseBar(e, idx) {
      this.viewData.forEach((item, index) => {
        if (index == idx) {
          item.showBar1 = false;
          item.showBar2 = false;
        }
      })
    },
    handleShowBar(e, idx) {
      console.log(e, idx, '2222222222')
      console.log(this.viewData)
      this.viewData.forEach((item, index) => {
        if (index == idx) {
          item.showBar1 = true;
          item.showBar2 = true
        } else {
          item.showBar1 = false;
          item.showBar2 = false
        }
      })
    },
    //点击添加功能模块
    addModul(idx) {
      //添加模块功能，先添加modelType确定模块类型，再根据模块类型添加相应的字段
      //1-搜索功能，2-轮播图，3-分类导航，4-图片导航，5-标题导航，6-活动导航，7-商品导航
      this.viewData.forEach(item => {
        item.showBar1 = false;
        item.showBar2 = false;
      })
      let modelType = idx + 1;
      let viewData = {
        modelType: modelType,
        showBar1: true,
        showBar2: true,
        modelOrder: this.viewData.length + 1,//模块排序
        modelDetail: {}, //模块详情
        layoutType: '1',//节日送礼排版 1-横版 2-竖版
        margin: '',
        goodsSelectedId: ''
      }
      let navModel = {
        navType: 0, //1-功能跳转，2-分类标签，3-商品
        funcName: '无',
        navUrl: '',
        pageType: 1,
        id: null //功能、分类或商品id
      }
      if (modelType == 1) {//搜索
        return
        let data = {
          navName: '',
          navModel: navModel
        }
        viewData.modelDetail = data
      } else if (modelType == 2) {//轮播图
        let data = {
          imgName: '',
          imgUrl: '',
          navModel: navModel
        }
        viewData.radioHeight = '1';
        viewData.height = '';
        viewData.modelDetail.swiperImageList = [data]
      } else if (modelType == 3) {//分类导航
        let data = {
          imgUrl: '',
          categoryNavName: '',
          navModel: navModel
        }
        let data2 = JSON.parse(JSON.stringify(data));
        viewData.modelDetail.categoryNavList = [data, data2]
        // setTimeout(()=>{viewData.modelDetail.categoryNavList.push(data)},200)

      } else if (modelType == 4 || modelType == 12) {// 图片导航
        let data = {
          imgUrl: '',
          navModel: navModel
        }
        viewData.modelDetail.imgList = [data]
      } else if (modelType == 5) {//标题导航
        let data = {
          mainTitle: '',
          subTitle: '',
          showType: 1, //1-居左，2-居中
          navModel: navModel
        }
        viewData.modelDetail = data
      } else if (modelType == 6) { //秒杀导航
        navModel.activeName = ''
        navModel.activeSubName = ''
        let data = {
          id: 1,
          showType: 5,// 5-一栏，2-两栏
          oneLan: 1,
          imgUrl: '',
          navModel: navModel
        }
        viewData.modelDetail.activityNavList = [data]
      } else if (modelType == 7) {//商品导航
        let data = {
          goodsType: 2,
          idList: [],
          goodsList: [],
          viewGoodsList: [],
          tagList: [],
          tagGoodsList: []
        }
        viewData.modelDetail = data
      } else if (modelType == 8) { //节日送礼
        return
        viewData.title = '节日送礼';
        viewData.subTitle = '好礼相送，共度佳节';
        viewData.btnTitle = '';
        viewData.navType = 0; //1-功能跳转，2-分类标签，3-商品
        viewData.funcName = '无';
        viewData.navUrl = '';
        let data = {
          imgUrl: '',
          festivalName: '',
          festivalDate: '',
          days: '',
          navModel: navModel
        }
        let data2 = JSON.parse(JSON.stringify(data))
        viewData.modelDetail.imgList = [data, data2]
      } else if (modelType == 9) { //名义送礼
        return
        viewData.title = '名义送礼';
        viewData.subTitle = '传递关怀的“心意”好礼';
        viewData.btnTitle = '更多好礼';
        viewData.navType = 0; //1-功能跳转，2-分类标签，3-商品
        viewData.funcName = '无';
        viewData.navUrl = '';
        let data = {
          labelId: null,
          labelName: '',
          goodsList: []
        }
        viewData.modelDetail.labelList = [data]
      } else if (modelType == 10) { //人群送礼
        return
        viewData.title = '人群送礼';
        viewData.subTitle = '不能错过的“精准”好礼';
        viewData.btnTitle = '更多好礼';
        viewData.navType = 0; //1-功能跳转，2-分类标签，3-商品
        viewData.funcName = '无';
        viewData.navUrl = '';
        let data = {
          labelId: null,
          labelName: '',
          goodsList: [],
          navModel: navModel
        }
        viewData.modelDetail.labelList = [data]
      } else if (modelType == 11) { //活动导航
        navModel.activeName = ''
        navModel.activeSubName = ''
        let data = {
          id: 1,
          showType: 5,// 5-一栏，2-两栏
          oneLan: 1,
          imgUrl: '',
          navModel: navModel
        }
        viewData.modelDetail.activityNavList = [data]
      } else if (modelType == 13) {//商品排行榜
        let data = {
          goodsType: 1,
          idList: [],
          goodsList: [
            {
              mainImage: '',
              name: '',
              price: '100.00',
              discount: '0.75',
              saleNum: 100
            }
          ],
          viewGoodsList: [
            {
              goods: {},
              navModel: navModel
            }
          ],

        }
        viewData.modelDetail = data
      }
      this.viewData.push(viewData)
      console.log(this.viewData)
      this.viewIndex = this.viewData.length - 1;
    },
    selectFunction(idx) {
      this.functionIndex = idx;
    },
    handleClose(e) {

    },
    toPage() {
      this.$router.push('./mallRenovation')
    }


  }


}
</script>
<style lang="scss" scoped>
input[type="text"],
input[type="number"] {
  -webkit-appearance: none;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #d8dce5;
  box-sizing: border-box;
  color: #5a5e66;
  display: inline-block;
  font-size: inherit;
  height: 40px;
  line-height: 1;
  outline: 0;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  width: 100%;

  &:hover {
    border-color: #b4bccc;
  }

  &:focus {
    border-color: #409EFF;
    outline: 0;
  }
}

.goodFirst {
  overflow-x: auto;
  width: 100%;
  // padding-left: 13px;
  // padding-right: 13px;
  box-sizing: border-box;

  .g-discount {
    width: 40px;
    height: 16px;
    background: linear-gradient(132deg, #2BDC9B 0%, #29B5E1 100%);
    border-radius: 2px 2px 2px 2px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 11px;
    color: #FFFFFF;
    line-height: 16px;
    text-align: center;
  }

  .g-sale {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 11px;
    color: #999999;
    line-height: 16px;
  }
}

.goods-Item {
  width: 143px;
  height: 252px;
  position: relative;
  margin-right: 10px;

  .goods-Item-num {
    width: 72px;
    height: 17px;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 12px;
    color: #FFFFFF;
    line-height: 17px;
    position: absolute;
    top: 3px;
    left: 5px;
    z-index: 10,
  }

  .goods-Item-status {
    width: 143px;
    height: 28px;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.4) 100%);
    border-radius: 0px 0px 6px 6px;
    font-weight: 400;
    font-size: 13px;
    color: #FFFFFF;
    line-height: 28px;
    text-align: center;
    position: absolute;
    left: 0;
    top: 115px;
    z-index: 10,
  }
}

.pr {
  width: 100%;
  min-height: 20px;
  position: relative;
  padding: 0 16px;
  box-sizing: border-box;
  cursor: move;
}

.pr1 {
  width: 100%;
  min-height: 20px;
  position: relative;
  // padding: 0 16px;
  box-sizing: border-box;
  cursor: move;
}

.bread-small {
  font-size: 16px;
}

.bread-active {
  color: black;
  border-bottom: 2px solid #2d46ee;
}

.page-content {
  width: 100%;
  display: flex;
  margin-top: 20px;
}

.phone-view {
  width: 375px;
  height: 667px;
  background: #fff;
  border-radius: 16px;
  margin-right: 56px;
  position: relative;
  background-image: url(../../../assets/img_iphone@2x.png);
  background-size: contain;
  background-repeat: no-repeat;
}

.phone-scroll {
  width: 100%;
  height: calc(100% - 88px);
  background-color: transparent;
  margin-top: 85px;
  overflow-y: auto;
  padding-top: 20px;
  box-sizing: border-box;
}

.phone-scroll::-webkit-scrollbar {
  display: none;
}

.phone-masker {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.phone-maskerimg {
  width: 250px;
  height: 300px;
  background-image: url(../../../assets/img_tanchuang@2x.png);
  background-repeat: no-repeat;
  background-size: contain;
}

.page-right {
  width: 1000px;
}

.right-title {
  width: 92px;
  height: 36px;
  background: #2d46ee;
  border-radius: 3px;
  font-size: 16px;
  margin-bottom: 40px;
  text-align: center;
  line-height: 36px;
  color: white;
}

.edit-title {
  font-size: 16px;
  color: #303033;
  font-weight: bold;
}

.line {
  width: 100%;
  height: 1px;
  background-color: #c0c0cc;
  margin: 18px auto;
}

.edit-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}

.edit-name {
  font-size: 14px;
  font-weight: bold;
}

.addbox {
  width: 64px;
  height: 64px;
  background: #ffffff;
  border: 1px solid #c0c0cc;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  /* margin-left: 20px; */
}

.addicon {
  width: 24px;
  height: 24px;
}

.el-table th>.cell {
  font-size: 14px !important;
  text-align: left !important;
  /* padding-left: 30px !important; */
}

.el-table td {
  text-align: left !important;
}

.toselect {
  width: 100%;
  height: 32px;
  background: #e9ecfe;
  border-radius: 3px;
  line-height: 32px;
  padding: 0 10px;
  box-sizing: border-box;
  font-size: 14px;
  color: #2d46ee;
}

.el-dialog__header {
  border-bottom: none;
}

.el-dialog__body {
  padding-top: 18px;
}

.function-box {
  width: 100%;
  height: 557px;
  display: flex;
  color: #303033;
}

/deep/ .el-radio {
  color: #303033;
}

.function-left {
  width: 198px;
  height: 64px;
  background: #ffffff;
}

.function-right {
  flex: 1;
  height: 557px;
  background: #ffffff;
  border: 1px solid #e9ecfe;
  padding: 18px;
  box-sizing: border-box;
}

.function-item {
  width: 100%;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 18px;
  box-sizing: border-box;
  font-size: 16px;
}

.function-item-active {
  background-color: #e9ecfe;
  color: #2d46ee;
}
.hide-menu{
  display: none;
}

.select-box {
  width: 100%;
  height: 48px;
  background: #ffffff;
  display: flex;
  align-items: center;
  padding: 0 18px;
  box-sizing: border-box;
}

.select-box-active {
  background: #e9ecfe;
}

.search-ipt {
  flex: 1 !important;
  /* width: 518px !important; */
  height: 36px !important;
  background: #ffffff;
  border: 1px solid #c0c0cc;
  border-radius: 3px;
}

.categary-box {
  width: 678px;
  overflow-x: auto;
  white-space: nowrap;
  margin-top: 18px;
  padding-bottom: 18px;
}

.categary-item {
  padding: 8px 15px;
  background-color: #e9ecfe;
  font-size: 14px;
  margin-right: 18px;
  display: inline-block;
  cursor: pointer;
}

.categary-active {
  background-color: #2d46ee;
  color: white;
}

.select-goods {
  height: 72px;
}

.select-goods .el-radio {
  display: flex;
  align-items: center;
}

.goods-box {
  display: flex;
  align-items: center;
  font-size: 14px;
}

.goods-img {
  width: 48px;
  height: 48px;
  background: #d1d1d1;
  margin-right: 8px;
}

.goods-num {
  color: #606066;
  margin-top: 10px;
}

.pagibox {
  display: flex;
  justify-content: flex-end;
  position: absolute;
  bottom: 6px;
  right: 0;
}

.modul {
  padding: 12px;
  border-radius: 6px;
  color: white;
  background-color: #2d46ee;
  margin-right: 18px;
  min-width: 182px;
  height: 780px;
  overflow-y: auto;
  box-sizing: border-box;
}

.modul-item {
  width: 140px;
  height: 64px;
  background: #e9ecfe;
  border-radius: 6px;
  display: flex;
  align-items: center;
  padding: 0 18px;
  margin-bottom: 8px;
  color: #2d46ee;
  cursor: pointer;
  box-sizing: border-box;
}

.addicon {
  width: 16px;
  height: 16px;
  margin-right: 4px;
}

.phone-search {
  width: 100%;
  height: 36px;
  background: #ffffff;
  border: 1px solid #f63c56;
  border-radius: 36px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  color: #cccccc;
  box-sizing: border-box;
}

.search-left {
  display: flex;
  align-items: center;
}

.search-icon {
  width: 18px;
  height: 18px;
  margin-right: 6px;
  margin-left: 10px;
}

.search-btn {
  // width: 58px;
  height: 32px;
  background: #f63c56;
  border-radius: 32px;
  color: white;
  // text-align: center;
  line-height: 32px;
  margin-right: 2px;
  padding: 0 16px;
}

.swiper-box {
  width: 100%;
  height: 124px;
  border-radius: 8px;
  background-color: #c0c0cc;
}

.swiper-img {
  width: 100%;
  height: auto;
  border-radius: 8px;
}

.mg-bttom {
  margin-bottom: 20px;
}

.title-box {
  display: flex;
  position: relative;
  color: #303033;
}

.main-title {
  font-size: 16px;
  font-weight: bold;
}

.secondary-title {
  font-size: 12px;
  color: #666666;
  position: absolute;
  right: 0;
  top: 2px;
}

.one-img {
  width: 100%;
  position: relative;

  .act-info {
    position: absolute;
    left: 8px;
    top: 12px;
  }

  .act-name {
    height: 24px;
    font-size: 20px;
    font-family: '黑体';
    font-weight: bold;
    font-style: italic;
    line-height: 1;
    color: #333333;
    overflow: hidden;
  }

  .act-intro {
    height: 14px;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 17px;
    color: #333333;
    opacity: 1;

  }
}

.active-img {
  width: 100%;
  height: auto;
  border-radius: 8px;
}

.active-img1 {
  width: 100%;
  height: auto;
  border-radius: 8px;
  padding: 1px 1px;
  box-sizing: border-box;
}

.two-img {
  display: flex;
  justify-content: space-between;
}

.two-img-box {
  flex: 1;
  height: 84px;
}

.phone-goods {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.phone-goods-item {
  width: 49%;
  height: 253px;
  position: relative;
}

.phone-goods-img {
  width: 100%;
  height: 167px;
  margin-bottom: 8px;
}

.phone-goods-title {
  width: 100%;
  padding: 0 6px;
  box-sizing: border-box;
  font-size: 14px;
  color: #333333;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}

.phone-goods-price {
  width: 100%;
  position: absolute;
  bottom: 4px;
  left: 0;
  padding: 0 6px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.retail-price {
  font-size: 16px;
  color: #f63c56;
  font-weight: bold;
}

.market-price {
  font-size: 12px;
  color: #999999;
}

.two-num {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.two-num-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #060606;
  margin-bottom: 20px;
}

.nav-img {
  width: 47px;
  height: 47px;
  margin-bottom: 8px;
}

/* .pr:hover .tool-bar{
    display: flex;
} */
.tool-bar {
  height: 31px;
  background-color: rgba(0, 0, 0, 0.4);
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  padding: 0 8px;
  box-sizing: border-box;
  justify-content: flex-end;
  font-size: 14px;
  color: white;
  z-index: 11;
  /* display: none; */
}

.bar-item {
  display: flex;
  align-items: center;
  margin-left: 14px;
  cursor: pointer;
}

.bar-img {
  width: 18px;
  height: 18px;
}

.nopage {
  height: 100%;
  overflow-y: auto;
}

.active-tipb {
  position: relative;
}

.active-pic-tips {
  width: 250px;
  height: auto;
  background: #ffffff;
  box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  padding: 18px 10px;
  box-sizing: border-box;
}

.active-pic-title {
  font-size: 14px;
  color: #303033;
  margin-bottom: 8px;
}

.onegag {
  width: 230px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  box-sizing: border-box;
  flex-direction: column;
  font-size: 12px;
  color: #909099;
  background-image: url(../../../assets/img_pic333.png);
  background-repeat: no-repeat;
  background-size: cover;
  margin-bottom: 18px;
}

.twogag {
  width: 113px;
  background-image: url(../../../assets/img_pic4@2x.png);
}

.el-popover {
  overflow: hidden;
  padding: 0;
}

.el-table [class*="el-table__row--level"] .el-table__expand-icon {
  display: none;
}

.bottom-box {
  width: 100%;
  height: 88px;
  border-top: 1px solid #ebebfa;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
}

.bottom-btn {
  width: 184px;
  height: 40px;
  background: #2d46ee;
  border-radius: 3px;
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}

/deep/ .el-message-box__status.el-icon-warning {
  color: #f63c56 !important;
}

/deep/ .el-message-box__status::before {
  color: #f63c56 !important;
}

.goods-type-button {
  width: 80px;
  height: 35px;
  font-size: 12px;
  color: #060606;
  text-align: center;
  line-height: 35px;
  border: 1px solid #d7d7d8;
  border-radius: 4px;
  box-sizing: border-box;
  margin-right: 30px;
  cursor: pointer;
  background-color: white;
}

.goods-type-active {
  background-color: #2d46ee;
  color: white;
}

///新后台
.festival-heng {
  width: 349px;
  height: 169px;
  border-radius: 16px;
  background-image: url(../../../assets/indexIcon/bg_songli_s.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin: 15px auto 0;
  overflow: hidden;
}

.name-heng {
  height: 228px;
  background-image: url(../../../assets/indexIcon/bg_mingyi.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.people-heng {
  height: 357px;
  background-image: url(../../../assets/indexIcon/bg_renqun.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.festival-top {
  margin-top: 16px;
  margin-left: 8px;
  display: flex;
  align-items: flex-end;
  color: #ffffff;
}

.festival-title {
  font-size: 18px;
  font-weight: bold;
  margin-right: 6px;
}

.festival-small-title {
  font-size: 13px;
}

.festival-two {
  width: 349px;
  height: 118px;
  background: #FFFFFF;
  border-radius: 16px;
  margin-top: 10px;
  padding: 10px 8px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}

.festival-two-item {
  width: 164px;
  height: 98px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
}

.festival-two-img {
  width: 100%;
  height: 100%;
}

.festival-date {
  display: inline-block;
  padding: 4px 10px;
  background-color: #FF9D1D;
  color: white;
  border-radius: 8px 12px 12px 0;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 12px;
}

.festival-btn {
  padding: 3px 13px;
  border: 1px solid #ffffff;
  border-radius: 12px;
  font-size: 13px;
  margin-right: 8px;
}

.name-scrollbox {
  width: 100%;
  height: 36px;
  border-radius: 16px 16px 0 0;
  background-color: #FDE9ED;
  position: relative;
  color: #EF1340;
  white-space: nowrap;
  padding-right: 5px;
  box-sizing: border-box;
}

.name-item {
  width: 94px;
  height: 36px;
  text-align: center;
  line-height: 36px;
  font-size: 14px;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  padding: 0 10px;
  box-sizing: border-box;
}

.name-item-active {
  width: 94px;
  height: 40px;
  position: absolute;
  left: 0;
  top: -4px;
  background-image: url(../../../assets/indexIcon/icon_mingyi_zuo.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  text-align: center;
  font-size: 15px;
  font-weight: bold;
  line-height: 40px;
}

.name-goods-box {
  width: 100%;
  height: 134px;
  background: #ffffff;
  border-radius: 0px 16px 16px 16px;
  display: flex;
  align-items: center;
  padding: 0 8px;
  box-sizing: border-box;
}

.name-goods-item {
  width: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 12px;
  color: #EF1340;
}

.name-goods-img {
  width: 80px;
  height: 80px;
  border: 1px solid #F63C56;
  border-radius: 8px;
  margin-bottom: 6px;
}

.name-goods-price {
  text-align: center;
}

.people-box {
  width: 100%;
  height: 300px;
  margin-top: 13px;
  display: flex;
  justify-content: space-between;
}

.people-left {
  width: 106px;
}

.people-left-item {
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  margin-bottom: 24px;
  position: relative;
}

.people-left-item-active {
  width: 101px;
  height: 36px;
  font-size: 14px;
  color: #7700B9;
  font-weight: bold;
  background-image: url(../../../assets/indexIcon/bg_sel.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: absolute;
  left: -4px;
  top: 0;
  line-height: 36px;
}

.people-right {
  width: 222px;
  height: 276px;
  margin-right: 9px;
  margin-top: 14px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.people-right-item {
  width: 107px;
  display: flex;
  flex-direction: column;
  font-size: 18px;
  color: #7700B9;
}

.people-right-img {
  width: 107px;
  height: 107px;
  border-radius: 8px;
  margin-bottom: 5px;
}

.newicon {
  width: 349px;
  height: 86px;
  display: block;
  margin: 0 auto;
}

.tag-item {
  padding: 2px 12px;
  font-size: 12px;
  color: #060606;
  border-radius: 12px;
  border: 1px solid #666666;
  margin-right: 14px;
  cursor: pointer;
}

.tag-item-active {
  background-color: #2d46ee;
  color: #ffffff;
  border: 1px solid #2d46ee;
}

.tag-disabled {
  color: #ffffff;
  background-color: #cccccc;
  border: 1px solid #cccccc;
  cursor: not-allowed;
}

.gift-tips {
  width: 32px;
  height: 16px;
  background: #F63C56;
  border-radius: 2px;
  margin-right: 4px;
  display: inline-block;
  font-size: 10px;
  color: #fff;
  text-align: center;
  line-height: 16px;
}
</style>